document.addEventListener("DOMContentLoaded", function () {
  const { DGSAppBaseUrl } = window;
  const discDesignProductId = document.getElementById("disc-design-productId");
  const discDesignVariantId = document.getElementById("disc-design-variantId");

  // Get a JSON object
  const variantId = discDesignVariantId.value;
  const productId = discDesignProductId.value;
  const designKey = `discDesign-${variantId}`;
  window.designKey = designKey;

  let discDesign = localStorage.getItem(designKey);
  if (discDesign) {
    discDesign = JSON.parse(discDesign);
  } else {
    discDesign = {
      productId,
      designKey,
      variantId,
      dataURL: "",
      json: "",
      type: "",
    };
  }

  /* ------------------------------------------------------------------------JS for creeate design tab------------------------------------------------------------------------------*/

  const wrapper = document.getElementById("canvas-wrapper");
  const overlay = document.getElementById("scrollable-overlay");
  const canvasEl = document.getElementById("disc-canvas");
  let canvas;
  let activeTextColor = "#000000";

  // Variables for canvas responsiveness
  let isResizing = false;
  let originalCanvasSize = 0;
  let isImporting = false;

  // Store curved text states for restoration
  let curvedTextStates = new Map();

  let images = []; // Array to store all uploaded images
  let activeImage = null; // Currently active image for scaling
  let initialDistance = 0;
  let initialScale = 1;

  // Native touch event handlers for mobile pinch zoom
  let touches = [];
  let isScaling = false;

  const hasSelectedImage = () => {
    const activeObject = canvas.getActiveObject();
    return activeObject && activeObject.type === "image";
  };
  let fillCropBtn = document.getElementById("fill-crop-btn");
  let maxSizeBtn = document.getElementById("max-size-btn");

  // Update button states based on selection for image
  function updateIamgeActionButtonStates() {
    let hasSelectedObjectImage = hasSelectedImage();

    fillCropBtn.disabled = !hasSelectedObjectImage;
    maxSizeBtn.disabled = !hasSelectedObjectImage;

    if (hasSelectedObjectImage) {
      // fillCropBtn.classList.remove("hidden");
      // maxSizeBtn.classList.remove("hidden");
      fillCropBtn.classList.remove("opacity-50", "cursor-not-allowed");
      maxSizeBtn.classList.remove("opacity-50", "cursor-not-allowed");
    } else {
      // fillCropBtn.classList.add("hidden");
      // maxSizeBtn.classList.add("hidden");
      fillCropBtn.classList.add("opacity-50", "cursor-not-allowed");
      maxSizeBtn.classList.add("opacity-50", "cursor-not-allowed");
    }
  }

  // Function to update overlay visibility based on canvas objects
  function updateOverlay() {
    const hasObjects = canvas.getObjects().length > 0;

    if (hasObjects) {
      // Canvas has objects - hide overlay to allow canvas interaction
      overlay.classList.remove("active");
    } else {
      // Canvas is empty - show overlay to allow scrolling
      overlay.classList.add("active");
    }
  }

  // Improved responsive resize with debouncing
  // Debounced resize handler
  let resizeTimeout;
  let lastViewportHeight = window.innerHeight;
  let isKeyboardOpen = false;
  let keyboardDetectionThreshold = 150; // pixels

  const handleResize = () => {
    if (isImporting) return;

    const currentViewportHeight = window.innerHeight;
    const heightDifference = Math.abs(
      lastViewportHeight - currentViewportHeight
    );

    // Detect if this is likely a keyboard event
    const isMobile = window.innerWidth <= 768;

    if (isMobile) {
      // On mobile, if height decreased significantly, it's likely keyboard opening
      if (
        currentViewportHeight < lastViewportHeight &&
        heightDifference > keyboardDetectionThreshold
      ) {
        isKeyboardOpen = true;
        // console.log("Mobile keyboard detected - skipping resize");
        return; // Don't resize canvas when keyboard opens
      }

      // If height increased significantly, keyboard might be closing
      if (
        currentViewportHeight > lastViewportHeight &&
        heightDifference > keyboardDetectionThreshold &&
        isKeyboardOpen
      ) {
        isKeyboardOpen = false;
        // console.log("Mobile keyboard closed - allowing resize");
        // Allow resize after keyboard closes
      }

      // If keyboard is open, don't resize
      if (isKeyboardOpen) {
        return;
      }
    }

    // Update last known viewport height
    lastViewportHeight = currentViewportHeight;

    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      resizeCanvas();
    }, 150);
  };

  // Alternative approach using visualViewport API (modern browsers)
  const handleResizeWithVisualViewport = () => {
    if (isImporting) return;

    // Use Visual Viewport API if available (better mobile support)
    if (window.visualViewport) {
      const viewport = window.visualViewport;
      const heightDifference = Math.abs(window.innerHeight - viewport.height);

      // If visual viewport height is significantly less than window height,
      // keyboard is likely open
      if (heightDifference > keyboardDetectionThreshold) {
        console.log(
          "Keyboard detected via Visual Viewport API - skipping resize"
        );
        return;
      }
    }

    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      resizeCanvas();
    }, 150);
  };

  function enableTabs() {
    const tabsToEnable = document.querySelectorAll(
      '.custom-tabs-nav li[data-tab="tab2"], .custom-tabs-nav li[data-tab="tab3"]'
    );

    tabsToEnable.forEach(tab => {
      if (tab.classList.contains("tabs-disabled")) {
        tab.classList.remove("tabs-disabled");
      }
    });
  }

  // --- Canvas Initialization ---
  const initializeCanvas = () => {
    const size = Math.min(wrapper.offsetWidth, 500); // Cap max size
    originalCanvasSize = size;

    // Set canvas element dimensions
    canvasEl.width = size;
    canvasEl.height = size;

    canvasEl.style.width = size + "px";
    canvasEl.style.height = size + "px";

    canvas = new fabric.Canvas("disc-canvas", {
      width: size,
      height: size,
      backgroundColor: "#ffffff",
      preserveObjectStacking: true, // Important: preserve stacking order

      enableRetinaScaling: true, // Automatically handles high DPI displays
    });

    // Add custom metadata
    canvas.meta = {
      designId: null,
    };

    // Create circular clip path
    const clipPath = new fabric.Circle({
      radius: size / 2,
      left: size / 2,
      top: size / 2,
      originX: "center",
      originY: "center",
      absolutePositioned: true,
    });

    clipPath.set({
      left: canvas.width / 2,
      top: canvas.height / 2,
    });

    canvas.clipPath = clipPath;
    canvas.renderAll();

    

    // Enhanced event listeners
    window.removeEventListener("resize", handleResize); // Remove old listener if exists
    window.addEventListener(
      "resize",
      handleResizeWithVisualViewport || handleResize
    );

    // Additional safeguards for mobile
    if ("visualViewport" in window) {
      window.visualViewport.addEventListener("resize", () => {
        // Only handle visual viewport changes that aren't keyboard-related
        const viewport = window.visualViewport;
        const isLikelyKeyboard = viewport.height < window.innerHeight * 0.75;

        if (!isLikelyKeyboard) {
          handleResizeWithVisualViewport();
        }
      });
    }
    

    // window.addEventListener("resize", () => {
    //   const wrapperWidth = wrapper.offsetWidth;

    //   // Give padding only for mobile screens
    //   const isMobile = window.innerWidth <= 768; // you can adjust breakpoint
    //   const padding = isMobile ? 10 : 0; // 5px padding on mobile

    //   const newSize = wrapperWidth - padding * 2;

    //   canvas.setWidth(newSize);
    //   canvas.setHeight(newSize);
    //   clipPath.set({
    //     radius: newSize / 2,
    //     left: newSize / 2,
    //     top: newSize / 2,
    //   });
    //   canvas.renderAll();
    // });

    // Canvas event listeners
    canvas.on("selection:created", updateControls);
    canvas.on("selection:updated", updateControls);
    canvas.on("selection:cleared", updateControls);

    // COMPREHENSIVE LOCK EVENT HANDLING

    // 1. Before selection - prevent automatic bring-to-front
    canvas.on("before:selection:cleared", function () {
      // Store all current positions before any selection change
      canvas.getObjects().forEach((obj, index) => {
        if (obj.metadata) {
          obj.metadata.currentIndex = index;
        }
      });
    });

    canvas.on("selection:updated", function (e) {
      const activeObject = e.selected[0];
      if (activeObject) {
        handleObjectActivation(activeObject);
      }
      updateControls();
    });

    // 2. Mouse down - prevent default behavior for locked objects
    canvas.on("mouse:down", function (options) {
      if (options.target) {
        const object = options.target;
        const currentIndex = canvas.getObjects().indexOf(object);

        // Always store current index
        if (object.metadata) {
          object.metadata.storedIndex = currentIndex;
        }

        // If object is locked, mark it for position restoration
        if ((object.metadata && object.metadata.isLocked) || object.locked) {
          object._needsPositionRestore = true;
          object._originalIndex = currentIndex;
          // console.log(`Locked object clicked at index ${currentIndex}`);
        }
      }
    });

    // 3. After selection - restore locked object positions
    canvas.on("selection:created", function (e) {
      const activeObject = e.selected && e.selected[0];
      if (activeObject) {
        setTimeout(() => {
          handleObjectActivation(activeObject);
          updateControls();
        }, 0);
      }
    });

    canvas.on("selection:updated", function (e) {
      const activeObject = e.selected && e.selected[0];
      if (activeObject) {
        setTimeout(() => {
          handleObjectActivation(activeObject);
          updateControls();
        }, 0);
      }
    });

    // 4. Object modified - prevent locked objects from changing layers
    canvas.on("object:modified", function (e) {
      const object = e.target;
      if ((object.metadata && object.metadata.isLocked) || object.locked) {
        restoreObjectToOriginalPosition(object);
      }
    });

    // 5. After render - ensure locked objects stay in position
    canvas.on("after:render", function () {
      // Check if any locked objects have moved and restore them
      canvas.getObjects().forEach((obj, currentIndex) => {
        if (
          ((obj.metadata && obj.metadata.isLocked) || obj.locked) &&
          obj.metadata &&
          obj.metadata.storedIndex !== undefined &&
          obj.metadata.storedIndex !== currentIndex
        ) {
          // Silently move back to correct position
          canvas.moveTo(obj, obj.metadata.storedIndex);
        }
      });
    });

    // Listen for object movements to update indices start here
    canvas.on("object:added", function (e) {
      updateOverlay();
      updateAllObjectIndices();
      // console.log("Object added. Current indices updated.");
    });

    canvas.on("object:removed", function (e) {
      updateOverlay();
      updateAllObjectIndices();
      // console.log("Object removed. Current indices updated.");
    });

    canvas.on("path:created", function (e) {
      updateAllObjectIndices();
    });

    canvas.on("selection:cleared", function (e) {
      updateOverlay();
      updateControls();
    });
    // Initial check
    updateOverlay();
    // Listen for object movements to update indices end here

    //  Images mobile scale mathod
    canvas.upperCanvasEl.addEventListener(
      "touchstart",
      function (e) {
        touches = Array.from(e.touches);
        if (touches.length === 2) {
          // Find if we're touching an image
          const pointer = canvas.getPointer(e.touches[0]);
          const targetObject = canvas.findTarget(e.touches[0]);

          if (targetObject && images.includes(targetObject)) {
            e.preventDefault();
            isScaling = true;
            activeImage = targetObject;
            initialDistance = getDistance(touches[0], touches[1]);
            initialScale = activeImage.scaleX || 1;
            canvas.setActiveObject(activeImage);
            canvas.discardActiveObject(); // Disable fabric controls during scaling
          }
        }
      },
      { passive: false }
    );

    canvas.upperCanvasEl.addEventListener(
      "touchmove",
      function (e) {
        if (
          e.touches.length === 2 &&
          activeImage &&
          isScaling &&
          initialDistance > 0
        ) {
          e.preventDefault();
          e.stopPropagation();

          const currentDistance = getDistance(e.touches[0], e.touches[1]);
          const ratio = currentDistance / initialDistance;
          const newScale = initialScale * ratio;

          // Calculate minimum scale based on image and canvas size
          const minScaleX = 50 / activeImage.width; // Minimum 50px width
          const minScaleY = 50 / activeImage.height; // Minimum 50px height
          const minScale = Math.max(minScaleX, minScaleY, 0.05); // At least 5% of original

          // Calculate maximum scale
          const maxScale = Math.min(
            5,
            2000 / Math.min(activeImage.width, activeImage.height)
          );

          // Apply limits
          const limitedScale = Math.max(minScale, Math.min(maxScale, newScale));

          activeImage.set({
            scaleX: limitedScale,
            scaleY: limitedScale,
          });

          canvas.renderAll();
        }
      },
      { passive: false }
    );

    canvas.upperCanvasEl.addEventListener("touchend", function (e) {
      if (e.touches.length < 2) {
        isScaling = false;
        initialDistance = 0;
        // Re-enable fabric controls
        if (activeImage) {
          canvas.setActiveObject(activeImage);
        }
        activeImage = null;
      }
    });

    // Handle when all touches are lifted
    canvas.upperCanvasEl.addEventListener("touchcancel", function (e) {
      isScaling = false;
      initialDistance = 0;
      if (activeImage) {
        canvas.setActiveObject(activeImage);
      }
      activeImage = null;
    });

    // Helper function to calculate distance between two touches
    function getDistance(touch1, touch2) {
      const dx = touch1.clientX - touch2.clientX;
      const dy = touch1.clientY - touch2.clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    // Mouse wheel zoom for desktop
    canvas.on("mouse:wheel", function (opt) {
      const activeObject = canvas.getActiveObject();
      if (activeObject && images.includes(activeObject)) {
        const delta = opt.e.deltaY;
        let zoom = activeObject.scaleX;
        zoom *= 0.999 ** delta;

        // Calculate minimum scale based on image size
        const minScaleX = 50 / activeObject.width;
        const minScaleY = 50 / activeObject.height;
        const minScale = Math.max(minScaleX, minScaleY, 0.05);
        const maxScale = Math.min(
          5,
          2000 / Math.min(activeObject.width, activeObject.height)
        );

        // Apply limits
        zoom = Math.max(minScale, Math.min(maxScale, zoom));

        activeObject.set({
          scaleX: zoom,
          scaleY: zoom,
        });
        canvas.renderAll();
        opt.e.preventDefault();
        opt.e.stopPropagation();
      }
    });

    // Selection events
    canvas.on("selection:created", function (e) {
      if (e.selected && e.selected[0] && images.includes(e.selected[0])) {
        initialDistance = 0;
        initialScale = e.selected[0].scaleX;
      }
    });

    canvas.on("selection:updated", function (e) {
      if (e.selected && e.selected[0] && images.includes(e.selected[0])) {
        initialDistance = 0;
        initialScale = e.selected[0].scaleX;
      }
    });

    // Handle object removal
    canvas.on("object:removed", function (e) {
      const removedObject = e.target;
      const index = images.indexOf(removedObject);
      if (index > -1) {
        images.splice(index, 1); // Remove from images array
      }
    });

    // code for mobile responsiveness

    // Add constraint system to prevent objects from going outside canvas
    // Constrain objects within canvas bounds
    // canvas.on("object:moving", function (e) {
    //   const obj = e.target;
    //   const padding = canvas.width * 0.05;

    //   // Calculate bounds considering object dimensions
    //   const objWidth = obj.getScaledWidth();
    //   const objHeight = obj.getScaledHeight();

    //   const minLeft = padding + objWidth / 2;
    //   const maxLeft = canvas.width - padding - objWidth / 2;
    //   const minTop = padding + objHeight / 2;
    //   const maxTop = canvas.height - padding - objHeight / 2;

    //   if (obj.left < minLeft) obj.left = minLeft;
    //   if (obj.left > maxLeft) obj.left = maxLeft;
    //   if (obj.top < minTop) obj.top = minTop;
    //   if (obj.top > maxTop) obj.top = maxTop;
    // });

    // Prevent objects from being scaled too large
    canvas.on("object:scaling", function (e) {
      const obj = e.target;
      const maxScale = 2.0;
      const minScale = 0.1;

      if (obj.scaleX > maxScale) obj.scaleX = maxScale;
      if (obj.scaleX < minScale) obj.scaleX = minScale;
      if (obj.scaleY > maxScale) obj.scaleY = maxScale;
      if (obj.scaleY < minScale) obj.scaleY = minScale;
    });

    // Detect focus events on text inputs to prevent resize
    canvas.on("text:editing:entered", () => {
      isKeyboardOpen = true;
      console.log("Text editing started - preventing resize");
    });

    canvas.on("text:editing:exited", () => {
      // Delay reset to allow keyboard to close
      setTimeout(() => {
        isKeyboardOpen = false;
        console.log("Text editing ended - allowing resize");
      }, 300);
    });
    // Monitor orientation changes (which should trigger resize)
    window.addEventListener("orientationchange", () => {
      // Force resize after orientation change (with delay for animation)
      setTimeout(() => {
        isKeyboardOpen = false; // Reset keyboard state
        lastViewportHeight = window.innerHeight;
        resizeCanvas();
      }, 500);
    });
  };

  

  // --- UI Control Elements ---
  const objectControls = document.getElementById("object-controls");
  const noObjectSelected = document.getElementById("no-object-selected");
  const textEffectsControls = document.getElementById("text-effects-controls");
  const aiLoadingIndicator = document.getElementById("ai-loading-indicator");
  const aiErrorMsg = document.getElementById("ai-error-msg");
  const generateAiImageBtn = document.getElementById("generate-ai-image-btn");

  const lockUnlockBtn = document.getElementById("lock-unlock-btn");
  const lockBtnText = document.getElementById("lock-btn-text");

  const updateControls = () => {
    const activeObject = canvas.getActiveObject();
    if (activeObject) {
      // objectControls.classList.remove("hidden");
      objectControls.classList.remove("opacity-50", "cursor-not-allowed");
      noObjectSelected.classList.add("hidden");

      if (activeObject.type === "i-text" || activeObject.type === "textbox") {
        // textEffectsControls.classList.remove("hidden");
        textEffectsControls.classList.remove(
          "opacity-50",
          "cursor-not-allowed"
        );
      } else {
        // textEffectsControls.classList.add("hidden");
        textEffectsControls.classList.add("opacity-50", "cursor-not-allowed");
      }
      // Update button states of image
      updateIamgeActionButtonStates();

      // Update lock button based on object state
      if (activeObject.locked) {
        if (lockBtnText) {
          lockBtnText.textContent = "🔒 Unlock Object";
          lockUnlockBtn.classList.remove(
            "bg-yellow-500",
            "hover:bg-yellow-600"
          );
          lockUnlockBtn.classList.add("bg-green-500", "hover:bg-green-600");
        }
      } else {
        if (lockBtnText) {
          lockBtnText.textContent = "🔓 Lock Object";
          lockUnlockBtn.classList.remove("bg-green-500", "hover:bg-green-600");
          lockUnlockBtn.classList.add("bg-yellow-500", "hover:bg-yellow-600");
        }
      }
    } else {
      // objectControls.classList.add("hidden");
      objectControls.classList.add("opacity-50", "cursor-not-allowed");
      // textEffectsControls.classList.add("hidden");
      textEffectsControls.classList.add("opacity-50", "cursor-not-allowed");
      noObjectSelected.classList.remove("hidden");
    }
  };

  // --- Background Color Palette Logic ---
  const bgColorPalette = document.getElementById("bg-color-palette");
  bgColorPalette.addEventListener("click", (e) => {
    if (e.target.tagName === "BUTTON") {
      bgColorPalette.querySelector(".selected")?.classList.remove("selected");
      e.target.classList.add("selected");
      const newBgColor = e.target.dataset.color;
      canvas.setBackgroundColor(newBgColor, canvas.renderAll.bind(canvas));
      handleChangeInCanvas();
    }
  });

  async function ensureFontLoaded(fontFamily) {
    const testFont = `16px "${fontFamily}"`;
    try {
      await document.fonts.load(testFont);
      await document.fonts.ready;
      // console.log(`✅ Font loaded: ${fontFamily}`);
    } catch (err) {
      console.warn(`⚠️ Font failed to load: ${fontFamily}`, err);
    }
  }

  // --- Text Color Palette Logic ---
  const textColorPalette = document.getElementById("text-color-palette");
  textColorPalette.addEventListener("click", (e) => {
    if (e.target.tagName === "BUTTON") {
      textColorPalette.querySelector(".selected")?.classList.remove("selected");
      e.target.classList.add("selected");
      activeTextColor = e.target.dataset.color;
      const activeObject = canvas.getActiveObject();
      // if (activeObject && activeObject.set) {
      if (activeObject && activeObject.type === "i-text") {
        activeObject.set("fill", activeTextColor);
        canvas.renderAll();
      }
    }
  });

  // --- Font Family Logic ---
  const fontFamilySelect = document.getElementById("font-family");
  fontFamilySelect.addEventListener("change", (e) => {
    (async () => {
      const activeObject = canvas.getActiveObject();
      if (activeObject && activeObject.type === "i-text") {
        let fontFamily = e.target.value;
        await ensureFontLoaded(fontFamily);
        activeObject.set("fontFamily", fontFamily);
        canvas.renderAll();
      }
    })();
  });

  // canvas responsiveness code start here

  // --- Helper Functions for Curve Text Management ---
  // const storeCurvedTextState = (textObj) => {
  //   if (textObj.type === "i-text" && textObj.path) {
  //     // Extract curve direction from path
  //     // let curveDirection = "straight";
  //     let curveDirection = getTextCurveDirection(textObj);

  //     if (textObj.path && textObj.path.path) {
  //       const pathCommands = textObj.path.path;
  //       // Look for Arc command and its sweep direction
  //       for (let i = 0; i < pathCommands.length; i++) {
  //         if (pathCommands[i][0] === "A") {
  //           curveDirection = pathCommands[i][5] === 0 ? "up" : "down";
  //           break;
  //         }
  //       }
  //     }

  //     curvedTextStates.set(textObj, {
  //       curveDirection: curveDirection,
  //       originalLeft: textObj.left,
  //       originalTop: textObj.top,
  //       wasRestored: false,
  //     });

  //     console.log(
  //       "Stored curve state:",
  //       curveDirection,
  //       "for text:",
  //       textObj.text
  //     );
  //   }
  // };

  // --- Curved Text Management ---
  // Fixed storeCurvedTextState function
  const storeCurvedTextState = (textObj) => {
    if (textObj.type === "i-text" && textObj.path) {
      const curveDirection = getTextCurveDirection(textObj);

      console.log(
        `Storing curve state: ${curveDirection} for text: ${textObj.text}`
      );

      curvedTextStates.set(textObj, {
        curveDirection: curveDirection, // This will be "up", "down", or "straight"
        originalLeft: textObj.left,
        originalTop: textObj.top,
      });
    }
  };
  const straightenCurvedText = (textObj) => {
    if (textObj.type === "i-text" && textObj.path) {
      storeCurvedTextState(textObj);
      textObj.set({ path: null });
      console.log("Straightened text:", textObj.text);
    }
  };

  const restoreCurvedText = (textObj, newCanvasSize) => {
    if (textObj.type === "i-text" && curvedTextStates.has(textObj)) {
      const state = curvedTextStates.get(textObj);
      console.log(
        "Restoring curve:",
        state.curveDirection,
        "for text:",
        textObj.text
      );

      if (state.curveDirection !== "straight" && !state.wasRestored) {
        applyCurveToText(textObj, state.curveDirection, newCanvasSize);
        state.wasRestored = true;
      }
    }
  };
  // Fixed applyCurveToText function
  const applyCurveToText = (textObj, direction, canvasSize = canvas.width) => {
    if (direction === "straight") {
      textObj.set({ path: null });
      return;
    }

    const radius = canvasSize * 0.4;
    const cx = canvasSize / 2;
    const cy = canvasSize / 2;

    // Fix the direction mapping - normalize the direction value
    let curveDirection;
    if (direction === "up" || direction === "curve up") {
      curveDirection = 0; // sweep-flag 0 for upward curve
    } else if (direction === "down" || direction === "curve down") {
      curveDirection = 1; // sweep-flag 1 for downward curve
    } else {
      curveDirection = 0; // default to up
    }

    const pathData = `M ${
      cx - radius
    }, ${cy} A ${radius},${radius} 0 0,${curveDirection} ${cx + radius},${cy}`;
    const path = new fabric.Path(pathData, { visible: false });

    textObj.set({
      path: path,
      textAlign: "center",
    });
  };

  // Fixed getTextCurveDirection function
  function getTextCurveDirection(obj) {
    if (!obj.path) {
      return "straight";
    }

    // Extract path data
    const pathData = obj.path.path || obj.path;

    // Find arc command
    for (let cmd of pathData) {
      const type = cmd[0];
      if (type === "A") {
        // Arc command: rx ry x-axis-rotation large-arc-flag sweep-flag x y
        const sweepFlag = cmd[5];
        return sweepFlag === 0 ? "up" : "down"; // Return consistent "up"/"down" values
      }
      if (type === "Q" || type === "C") {
        // Control point(s) determine curvature
        const cpY = type === "Q" ? cmd[2] : cmd[2]; // quadratic vs cubic
        const endY = cmd[cmd.length - 1];

        if (cpY < endY) return "up";
        if (cpY > endY) return "down";
      }
    }

    return "straight";
  }
  // // Update clip path for new canvas size
  // const applyCurveToText = (textObj, direction, canvasSize = canvas.width) => {
  //   if (direction === "straight") {
  //     textObj.set({ path: null });
  //     return;
  //   }

  //   const radius = canvasSize * 0.35;
  //   const cx = canvasSize / 2;
  //   const cy = canvasSize / 2;
  //   const curveDirection = direction === "up" ? 0 : 1;

  //   const pathData = `M ${
  //     cx - radius
  //   }, ${cy} A ${radius},${radius} 0 0,${curveDirection} ${cx + radius},${cy}`;
  //   const path = new fabric.Path(pathData, { visible: false });

  //   textObj.set({
  //     path: path,
  //     textAlign: "center",
  //   });

  //   // Store the curve state
  //   curvedTextStates.set(textObj, {
  //     curveDirection: direction,
  //     originalLeft: textObj.left,
  //     originalTop: textObj.top,
  //   });
  // };

  // const getTextCurveDirection = (obj) => {
  //   if (!obj.path?.path) return "straight";

  //   const pathData = obj.path.path;
  //   for (let cmd of pathData) {
  //     if (cmd[0] === "A") {
  //       return cmd[5] === 0 ? "up" : "down";
  //     }
  //   }
  //   return "straight";
  // };
  const updateClipPath = (size) => {
    const clipPath = new fabric.Circle({
      radius: size / 2,
      left: size / 2,
      top: size / 2,
      originX: "center",
      originY: "center",
    });
    canvas.clipPath = clipPath;
  };

  // --- Enhanced Responsive Canvas Resize with Curve Text Management ---
  // Improved version of your existing resizeCanvas function with mobile checks
  const resizeCanvas = () => {
    let currentTab= window.getActiveTabId();
    if (isResizing || isImporting || isKeyboardOpen || currentTab!="tab1") return;
    // Additional mobile keyboard check
    const isMobile = window.innerWidth <= 768;
    if (isMobile && window.visualViewport) {
      const viewport = window.visualViewport;
      const heightDifference = window.innerHeight - viewport.height;

      if (heightDifference > keyboardDetectionThreshold) {
        console.log("Resize blocked - keyboard still detected");
        return;
      }
    }
    isResizing = true;

    const oldSize = canvas.width;
    // Give padding only for mobile screens
    let wrapperWidth = wrapper.offsetWidth;

    const padding = isMobile ? 10 : 0; // 5px padding on mobile
    if (wrapperWidth > padding * 2) {
      wrapperWidth = wrapper.offsetWidth - padding * 2;
    }
    const newSize = Math.min(wrapperWidth, 500);
    if (oldSize === newSize) {
      isResizing = false;
      return;
    }
    const scaleFactor = newSize / oldSize;

    // Store the current active object to restore later
    const activeObject = canvas.getActiveObject();
    canvas.discardActiveObject();

    // Step 1: Straighten all curved text and store their states
    const objects = canvas.getObjects();
    const textObjectsToRestore = [];

    objects.forEach((obj) => {
      if (obj.type === "i-text") {
        if (obj.path) {
          straightenCurvedText(obj);
          textObjectsToRestore.push(obj);
        }
      }
    });

    // Render canvas after straightening text
    canvas.renderAll();

    // Step 2: Scale all objects proportionally AFTER straightening text
    objects.forEach((obj) => {
      if (obj.type === "i-text" || obj.type === "text") {
        // For text objects, handle differently to maintain position accuracy
        const currentLeft = obj.left;
        const currentTop = obj.top;

        // Calculate relative position (0-1 scale)
        const relativeLeft = currentLeft / oldSize;
        const relativeTop = currentTop / oldSize;

        // Apply new absolute position
        let newLeft = relativeLeft * newSize;
        let newTop = relativeTop * newSize;

        // Constrain text within canvas boundaries with padding
        const padding = newSize * 0.1; // 10% padding from edges
        newLeft = Math.max(padding, Math.min(newSize - padding, newLeft));
        newTop = Math.max(padding, Math.min(newSize - padding, newTop));

        // Calculate new font size with specified limit
        const fontSize = Math.min(obj.fontSize * scaleFactor, 40);

        obj.set({
          left: newLeft,
          top: newTop,
          fontSize: fontSize,
        });
      } else {
        // For images and other objects, use the original scaling method
        let newLeft = obj.left * scaleFactor;
        let newTop = obj.top * scaleFactor;

        // Constrain images within canvas boundaries
        const padding = newSize * 0.05; // 5% padding for images
        newLeft = Math.max(padding, Math.min(newSize - padding, newLeft));
        newTop = Math.max(padding, Math.min(newSize - padding, newTop));

        obj.set({
          left: newLeft,
          top: newTop,
          scaleX: obj.scaleX * scaleFactor,
          scaleY: obj.scaleY * scaleFactor,
        });
      }

      obj.setCoords();
    });

    // Step 3: Resize canvas AFTER scaling objects
    canvas.setWidth(newSize);
    canvas.setHeight(newSize);

    // Update clip path
    const clipPath = canvas.clipPath;
    if (clipPath) {
      clipPath.set({
        radius: newSize / 2,
        left: newSize / 2,
        top: newSize / 2,
      });
    }

    // Step 4: Restore curved text after resize is complete
    setTimeout(() => {     

      textObjectsToRestore.forEach((textObj) => {
        // Reset the wasRestored flag before restoration
        if (curvedTextStates.has(textObj)) {
          curvedTextStates.get(textObj).wasRestored = false;
        }

        restoreCurvedText(textObj, newSize);
      });

      // Restore active object if it existed
      if (activeObject) {
        canvas.setActiveObject(activeObject);
      }

      canvas.renderAll();
      
      isResizing = false;

      // enable teh tabs
      enableTabs();

    }, 200); // Increased delay to ensure canvas resize is complete
  };
  // // --- Enhanced Responsive Canvas Resize ---
  // const resizeCanvas = () => {
  //   if (isResizing || isImporting) return;
  //   isResizing = true;

  //   const oldSize = canvas.width;

  //   // Give padding only for mobile screens
  //   let wrapperWidth = wrapper.offsetWidth;
  //   const isMobile = window.innerWidth <= 768; // you can adjust breakpoint
  //   const padding = isMobile ? 10 : 0; // 5px padding on mobile
  //   if(wrapperWidth>padding * 2){
  //     wrapperWidth = wrapper.offsetWidth - padding * 2;
  //   }
  //   const newSize = Math.min(wrapperWidth, 500);

  //   if (oldSize === newSize) {
  //     isResizing = false;
  //     return;
  //   }

  //   const scaleFactor = newSize / oldSize;

  //   // Store active object
  //   const activeObject = canvas.getActiveObject();
  //   canvas.discardActiveObject();

  //   // Scale all objects
  //   const objects = canvas.getObjects();
  //   objects.forEach((obj) => {
  //     // Handle different object types
  //     if (obj.type === "i-text" || obj.type === "text") {
  //       const newLeft = obj.left * scaleFactor;
  //       const newTop = obj.top * scaleFactor;
  //       const newFontSize = Math.min(obj.fontSize * scaleFactor, 48);

  //       obj.set({
  //         left: newLeft,
  //         top: newTop,
  //         fontSize: newFontSize,
  //       });

  //       // Handle curved text paths
  //       if (obj.path?.path) {
  //         obj.path.path.forEach((command) => {
  //           for (let i = 1; i < command.length; i++) {
  //             if (typeof command[i] === "number") {
  //               command[i] *= scaleFactor;
  //             }
  //           }
  //         });
  //       }
  //     } else {
  //       // Scale other objects normally
  //       obj.set({
  //         left: obj.left * scaleFactor,
  //         top: obj.top * scaleFactor,
  //         scaleX: obj.scaleX * scaleFactor,
  //         scaleY: obj.scaleY * scaleFactor,
  //       });
  //     }

  //     obj.setCoords();
  //   });

  //   // Resize canvas
  //   canvas.setWidth(newSize);
  //   canvas.setHeight(newSize);

  //   canvasEl.style.width = newSize + "px";
  //   canvasEl.style.height = newSize + "px";

  //   // Update clip path
  //   updateClipPath(newSize);

  //   // Restore active object
  //   if (activeObject) {
  //     canvas.setActiveObject(activeObject);
  //   }

  //   canvas.renderAll();
  //   isResizing = false;
  // };

  // canvas responsiveness code end here

  // Version 1
  function createIText(text, fontFamily, baseFontSize) {
    const textObj = new fabric.IText(text, {
      left: canvas.width / 2,
      top: canvas.height / 2,
      fill: activeTextColor,
      fontFamily: fontFamily,
      fontSize: baseFontSize, // 40
      originX: "center",
      originY: "center",
      textAlign: "center",
      cornerColor: "#4299e1",
      cornerSize: 12,
      transparentCorners: false,
    });
    return textObj;
  }

  // --- Add Text Functionality with Dynamic Responsive Sizing ---
  document.getElementById("add-text-btn").addEventListener("click", () => {
    (async () => {
      const textInput = document.getElementById("text-input");
      const text = textInput.value.trim();
      const fontFamily = fontFamilySelect.value;
      if (!text) {
        alert("Please enter some text first!");
        return;
      }

      // Calculate responsive font size based on current canvas size

      const currentCanvasSize = canvas.width;
      let baseFontSize = Math.max(currentCanvasSize * 0.08, 16);
      baseFontSize = Math.min(baseFontSize, 40);

      if (currentCanvasSize <= 300) {
        baseFontSize = Math.max(currentCanvasSize * 0.06, 16);
      } else if (currentCanvasSize <= 400) {
        baseFontSize = Math.max(currentCanvasSize * 0.07, 20);
      } else if (currentCanvasSize <= 500) {
        baseFontSize = Math.max(currentCanvasSize * 0.08, 24);
      } else {
        baseFontSize = Math.max(currentCanvasSize * 0.08, 28);
      }

      baseFontSize = Math.min(baseFontSize, 40);

      // ✅ Ensure font is loaded before rendering text
      await ensureFontLoaded(fontFamily);
      // Calculate appropriate width for text wrapping (80% of canvas width)
      const maxWidth = canvas.width * 1;
      // let textObj = createTextBox(text, fontFamily, maxWidth);

      let textObj = createIText(text, fontFamily, baseFontSize);

      // Add metadata to the text object
      addMetadataToObject(textObj, {
        text: text,
        fontFamily: fontFamily,
        color: activeTextColor,
        userCreated: true,
      });

      canvas.add(textObj);
      canvas.setActiveObject(textObj);
      canvas.renderAll();
      textInput.value = "";
      handleChangeInCanvas();
    })();
  });

  // --- STABLE CURVE BUTTON LOGIC ---
  // function applyCurve(direction) {
  //   const activeObject = canvas.getActiveObject();
  //   if (
  //     activeObject &&
  //     (activeObject.type === "textbox" || activeObject.type === "i-text")
  //   ) {
  //     // Create a path for the text to follow
  //     const radius = canvas.width * 0.4;
  //     const cx = canvas.width / 2;
  //     const cy = canvas.height / 2;
  //     // M is Move, A is Arc. `direction` 0 for up, 1 for down
  //     const pathData = `M ${
  //       cx - radius
  //     }, ${cy} A ${radius},${radius} 0 0,${direction} ${cx + radius},${cy}`;
  //     const path = new fabric.Path(pathData, { visible: false });

  //     activeObject.set({
  //       path: path,
  //       textAlign: "center",
  //     });
  //     canvas.renderAll();
  //     handleChangeInCanvas();
  //   }
  // }
  // --- IMPROVED CURVE BUTTON LOGIC ---
  function applyCurve(direction) {
    const activeObject = canvas.getActiveObject();
    if (activeObject && activeObject.type === "i-text") {
      // Store the curve state
      const curveDir = direction === 0 ? "up" : "down";
      curvedTextStates.set(activeObject, {
        curveDirection: curveDir,
        originalLeft: activeObject.left,
        originalTop: activeObject.top,
        wasRestored: false,
      });

      console.log("Applying curve:", curveDir, "to text:", activeObject.text);
      applyCurveToText(activeObject, curveDir);
      canvas.renderAll();
      handleChangeInCanvas();
    }
  }

  // document
  //   .getElementById("curve-up-btn")
  //   .addEventListener("click", () => applyCurve(0));

  document.getElementById("curve-up-btn").addEventListener("click", () => {
    const activeObject = canvas.getActiveObject();
    if (activeObject && activeObject.type === "i-text") {
      applyCurveToText(activeObject, "up");
      canvas.renderAll();
    }
  });
  // document
  //   .getElementById("curve-down-btn")
  //   .addEventListener("click", () => applyCurve(1));

  document.getElementById("curve-down-btn").addEventListener("click", () => {
    const activeObject = canvas.getActiveObject();
    if (activeObject && activeObject.type === "i-text") {
      applyCurveToText(activeObject, "down");
      canvas.renderAll();
    }
  });
  document.getElementById("straighten-btn").addEventListener("click", () => {
    const activeObject = canvas.getActiveObject();
    if (
      activeObject &&
      (activeObject.type === "textbox" || activeObject.type === "i-text")
    ) {
      applyCurveToText(activeObject, "straight");

      // Update stored state to straight
      curvedTextStates.set(activeObject, {
        curveDirection: "straight",
        originalLeft: activeObject.left,
        originalTop: activeObject.top,
        // wasRestored: false,
      });

      console.log("Making text straight:", activeObject.text);

      activeObject.set({ path: null });
      canvas.renderAll();
    }
  });

  const imageUploadErrorMsg = document.getElementById("image-upload-error-msg");

  // --- Add Image From Upload Functionality with Responsive Sizing ---
  document.getElementById("image-upload").addEventListener("change", (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) return;

    imageUploadErrorMsg.classList.add("hidden");
    imageUploadErrorMsg.innerHTML = ``;

    const validTypes = [
      "image/jpeg",
      "image/png",
      "image/gif",
      "image/webp",
      "image/bmp",
      "image/svg+xml",
    ];

    if (!validTypes.includes(file.type)) {
      imageUploadErrorMsg.classList.remove("hidden");
      imageUploadErrorMsg.innerHTML = `Error: Unsupported file type. Please upload a JPEG, PNG, GIF, WebP, BMP, or SVG image.`;
      e.target.value = "";
      return;
    }

    const MAX_SIZE_MB = 20;
    const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;

    if (file.size > MAX_SIZE_BYTES) {
      imageUploadErrorMsg.classList.remove("hidden");
      imageUploadErrorMsg.innerHTML = `Error: File is too large. Please upload an image smaller than ${MAX_SIZE_MB} MB.`;
      e.target.value = "";
      return;
    }

    const reader = new FileReader();
    reader.onload = async (f) => {
      let dataUrl = f.target.result;

      // ✅ Convert SVG to PNG if needed
      if (file.type === "image/svg+xml") {
        try {
          dataUrl = await convertSvgToPng(dataUrl);
        } catch (err) {
          imageUploadErrorMsg.classList.remove("hidden");
          imageUploadErrorMsg.innerHTML = `Error: Failed to convert SVG to PNG.`;
          e.target.value = "";
          return;
        }
      }

      fabric.Image.fromURL(dataUrl, (img) => {
        // Calculate responsive image size
        const maxSize = canvas.width * 0.4;
        const scaleFactor = Math.min(maxSize / img.width, maxSize / img.height);

        const canvasCenterX = canvas.width / 2;
        const canvasCenterY = canvas.height / 2;

        // Scale image to fit canvas nicely
        const maxWidth = canvas.width * 0.6;
        const maxHeight = canvas.height * 0.6;

        // Calculate initial scale to fit image properly
        const scaleX = maxWidth / img.width;
        const scaleY = maxHeight / img.height;
        const initialScale = Math.min(scaleX, scaleY, 1);

        // Position images with slight offset for multiple uploads
        let i = 0;
        const offsetX = (i % 3) * 50 - 50; // Spread images horizontally
        const offsetY = Math.floor(i / 3) * 50 - 25; // Stack vertically after 3

        img.set({
          scaleX: scaleFactor,
          scaleY: scaleFactor,
          left: canvasCenterX,
          top: canvasCenterY,
          originX: "center",
          originY: "center",

          selectable: true,
          moveable: true,
        });

        // Add metadata to the image object
        addMetadataToObject(img, {
          fileName: file.name,
          fileSize: file.size,
          fileType: file.type,
          uploadedAt: new Date().toISOString(),
          source: "user_upload",
        });

        canvas.add(img);
        canvas.setActiveObject(img);
        canvas.renderAll();
        images.push(img); // Add to images array

        // Update button states
        updateIamgeActionButtonStates();
        handleChangeInCanvas();
      });
    };
    reader.readAsDataURL(file);
    e.target.value = "";
  });

  // ✅ SVG to PNG converter function
  async function convertSvgToPng(svgDataUrl) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = function () {
        const canvasEl = document.createElement("canvas");
        canvasEl.width = img.width;
        canvasEl.height = img.height;
        const ctx = canvasEl.getContext("2d");
        ctx.drawImage(img, 0, 0);
        try {
          const pngDataUrl = canvasEl.toDataURL("image/png");
          resolve(pngDataUrl);
        } catch (e) {
          reject(e);
        }
      };
      img.onerror = reject;
      img.src = svgDataUrl;
    });
  }

  // --- AI Image Generation ---
  generateAiImageBtn.addEventListener("click", async () => {
    // check user is logged in or not
    if (
      window.ShopifyCustomerLoggedIn !== true &&
      window.ShopifyCustomerLoggedIn !== "true"
    ) {
      if (
        confirm(
          "You need to log in to generate the image through AI. Would you like to log in now?"
        )
      ) {
        window.location.href = window.ShopifyLoginUrl;
      }
      return;
    }
    const prompt = document.getElementById("ai-prompt-input").value;
    if (!prompt) {
      aiErrorMsg.textContent = "Please enter a prompt to generate an image.";
      aiErrorMsg.classList.remove("hidden");
      setTimeout(() => aiErrorMsg.classList.add("hidden"), 3000);
      return;
    }

    aiLoadingIndicator.classList.remove("hidden");
    generateAiImageBtn.disabled = true;
    generateAiImageBtn.classList.add("opacity-50", "cursor-not-allowed");
    aiErrorMsg.classList.add("hidden");

    try {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      let customerEmail = window.ShopifyCustomerEmail;
      const response = await fetch(
        `${DGSAppBaseUrl}/disc-designs/generate-image`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ prompt, customerEmail, timezone }),
        }
      );

      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.error || "Failed to generate image.");
      }
      let { status, message, data = {}, error = {} } = result || {};
      let imagePath;

      if (status === true) {
        imagePath = data.imagePath;
        let { origin } = window.location;
        let imageUrl = origin + "/" + imagePath;

        fabric.Image.fromURL(imageUrl, (img) => {
          // // Calculate responsive image size for AI images
          // const maxSize = canvas.width * 1;
          // const scaleFactor = Math.min(
          //   maxSize / img.width,
          //   maxSize / img.height
          // );
          // img.set({
          //   left: 0,
          //   top: 0,
          //   originX: "left",
          //   originY: "top",
          //   scaleX: scaleFactor,
          //   scaleY: scaleFactor,
          //   selectable: true,
          //   cornerColor: "#4299e1",
          //   cornerSize: 12,
          //   transparentCorners: false,
          // });

          const canvasWidth = canvas.width;
          const canvasHeight = canvas.height;
          const imgWidth = img.width;
          const imgHeight = img.height;

          // Calculate scale to fill the canvas completely
          const scaleX = canvasWidth / imgWidth;
          const scaleY = canvasHeight / imgHeight;
          const fillScale = Math.max(scaleX, scaleY); // Use max to fill entire canvas

          img.set({
            left: canvasWidth / 2,
            top: canvasHeight / 2,
            originX: "center",
            originY: "center",
            scaleX: fillScale,
            scaleY: fillScale,
            selectable: true,
            cornerColor: "#4299e1",
            cornerSize: 12,
            transparentCorners: false,
            fillMode: "cover", // Add this to track that it's meant to fill
          });

          // Add metadata to the AI-generated image object
          addMetadataToObject(img, {
            prompt: prompt,
            imagePath: imagePath,
            imageUrl: imageUrl,
            generatedAt: new Date().toISOString(),
            source: "ai_generated",
            customerEmail: customerEmail,
            timezone: timezone,
            aiProvider: "open ai", // or whatever AI service you're using
          });

          canvas.add(img);
          canvas.setActiveObject(img);
          canvas.renderAll();
          images.push(img); // Add to images array

          // Update button states
          updateIamgeActionButtonStates();
          handleChangeInCanvas();
        });
      } else {
        throw new Error(
          message || error.message || "Failed to generate image."
        );
      }
    } catch (error) {
      console.error("AI Image Generation Error:", error);
      aiErrorMsg.textContent =
        error.message || "An unknown error occurred. Please try again.";
      aiErrorMsg.classList.remove("hidden");
    } finally {
      aiLoadingIndicator.classList.add("hidden");
      generateAiImageBtn.disabled = false;
      generateAiImageBtn.classList.remove("opacity-50", "cursor-not-allowed");
    }
  });

  // Fill and Crop - scales selected image to fill entire canvas
  function fillAndCrop() {
    const activeObject = canvas.getActiveObject();
    if (!activeObject || activeObject.type !== "image") return;

    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;
    const imgWidth = activeObject.width;
    const imgHeight = activeObject.height;

    // Calculate scale to fill the canvas (cover behavior)
    const scaleX = canvasWidth / imgWidth;
    const scaleY = canvasHeight / imgHeight;
    const scale = Math.max(scaleX, scaleY)*1.1;

    activeObject.set({
      scaleX: scale,
      scaleY: scale,
      left: canvasWidth / 2,
      top: canvasHeight / 2,
      originX: "center",
      originY: "center",
    });

    canvas.renderAll();
  }

  // Max Full Size - fits entire selected image within canvas bounds
  function maxFullSize() {
    const activeObject = canvas.getActiveObject();
    if (!activeObject || activeObject.type !== "image") return;

    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;
    const imgWidth = activeObject.width;
    const imgHeight = activeObject.height;

    // Calculate scale to fit within canvas (contain behavior)
    const scaleX = canvasWidth / imgWidth;
    const scaleY = canvasHeight / imgHeight;
    const scale = Math.min(scaleX, scaleY);

    activeObject.set({
      scaleX: scale,
      scaleY: scale,
      left: canvasWidth / 2,
      top: canvasHeight / 2,
      originX: "center",
      originY: "center",
    });

    canvas.renderAll();
  }

  fillCropBtn.addEventListener("click", fillAndCrop);
  maxSizeBtn.addEventListener("click", maxFullSize);

  // --- General Object Controls (STABLE LAYERING) ---
  document.getElementById("delete-btn").addEventListener("click", () => {
    const activeObject = canvas.getActiveObject();
    if (activeObject) {
      if (curvedTextStates.has(activeObject)) {
        curvedTextStates.delete(activeObject);
      }

      canvas.remove(activeObject);
      canvas.discardActiveObject();
      canvas.renderAll();
      handleChangeInCanvas();
    }
  });

  document.getElementById("bring-forward-btn").addEventListener("click", () => {
    const activeObject = canvas.getActiveObject();
    if (activeObject) {
      canvas.bringForward(activeObject);
      // Force complete re-render
      canvas.discardActiveObject();
      canvas.renderAll();
      // canvas.setActiveObject(activeObject);
      canvas.fire("path:created"); // Trigger refresh event
    }
  });

  document.getElementById("send-backward-btn").addEventListener("click", () => {
    const activeObject = canvas.getActiveObject();
    if (activeObject) {
      canvas.sendBackwards(activeObject);
      // Force complete re-render
      canvas.discardActiveObject();
      canvas.renderAll();
      // canvas.setActiveObject(activeObject);
      canvas.fire("path:created"); // Trigger refresh event
    }
  });

  let sucessMessageDisappearTime = 1500;

  // Check if canvas has at least one text input or image
  const hasValidObjects = () => {
    let saveDesignBtn = document.getElementById("save-design-btn");
    let saveGuestDesignBtn = document.getElementById("save-guest-design-btn");
    const clearCanvasBtn = document.getElementById("clear-canvas-button");
    const productQuantityHtmlWrapper = document.querySelector(
      ".create_design_product_quantity_html_wrapper"
    );
    const createDesignAddToCartBtn = document.querySelector(
      ".createDesignAddToCartBtn"
    );

    const objects = canvas.getObjects();

    const hasText = objects.some(
      (obj) =>
        ["textbox", "i-text", "text"].includes(obj.type) &&
        obj.text &&
        obj.text.trim() !== ""
    );

    const hasImage = objects.some((obj) => obj.type === "image");

    const bgColor = canvas.backgroundColor;
    const isWhiteBg =
      !bgColor ||
      bgColor === "white" ||
      bgColor === "#ffffff" ||
      bgColor === "rgb(255,255,255)";

    let isValid = hasText || hasImage || !isWhiteBg;
    if (isValid) {
      saveDesignBtn?.classList.remove("disabled-save-btn");
      saveGuestDesignBtn?.classList.remove("disabled-save-btn");
      clearCanvasBtn?.classList.remove("disabled-save-btn");

      productQuantityHtmlWrapper?.classList.remove("disabled-save-btn");
      createDesignAddToCartBtn?.classList.remove("disabled-save-btn");
    } else {
      saveDesignBtn?.classList.add("disabled-save-btn");
      saveGuestDesignBtn?.classList.add("disabled-save-btn");
      clearCanvasBtn?.classList.add("disabled-save-btn");

      productQuantityHtmlWrapper?.classList.add("disabled-save-btn");
      createDesignAddToCartBtn?.classList.add("disabled-save-btn");
    }
    return isValid;
  };

  // --- Save Guest Design Selectors---
  const saveGuuestLoadingIndicator = document.getElementById(
    "save-guest-loading-indicator"
  );
  const saveGuestDesignBtn = document.getElementById("save-guest-design-btn");

  // --- Save Design Selectors---
  const saveLoadingIndicator = document.getElementById(
    "save-loading-indicator"
  );
  const saveDesignBtn = document.getElementById("save-design-btn");

  //--- Save as Design Selectors ----
  const saveAsLoadingIndicator = document.getElementById(
    "save-as-loading-indicator"
  );
  const saveAsDesignBtn = document.getElementById("save-as-continue-btn");

  // Enhanced JSON export with complete metadata preservation
  function exportCanvasWithMetadata() {
    // Get base canvas data
    // const canvasData = canvas.toJSON();
    const canvasData = canvas.toJSON(["clipPath"]);

    // Add comprehensive metadata for all objects
    canvasData.objects = canvasData.objects.map((obj, index) => {
      const fabricObj = canvas.getObjects()[index];

      // Base object data with metadata
      let enhancedObj = {
        ...obj,
        // Preserve existing metadata if it exists
        metadata: fabricObj.metadata
          ? {
              ...fabricObj.metadata,
              exportedAt: new Date().toISOString(),
              currentIndex: index,
            }
          : {
              id: generateUniqueId(),
              type: obj.type,
              currentIndex: index,
              exportedAt: new Date().toISOString(),
              category: getObjectCategory(obj.type),
            },
      };

      // Add curve metadata for text objects with paths
      if ((obj.type === "i-text" || obj.type === "textbox") && obj.path) {
        let curveDirection = 0; // up
        let curveRadius = canvas.width * 0.4;
        let curveCenterX = obj.left;
        let curveCenterY = obj.top;

        if (obj.path && obj.path.path) {
          const pathCommands = obj.path.path;

          // Analyze path to extract curve parameters
          for (let i = 0; i < pathCommands.length; i++) {
            const command = pathCommands[i];

            if (command[0] === "M") {
              const startX = command[1];
              const startY = command[2];

              // Look for curve command
              const nextCommand = pathCommands[i + 1];
              if (nextCommand && nextCommand[0] === "C") {
                const endX = nextCommand[5] || nextCommand[3];
                const endY = nextCommand[6] || nextCommand[4];
                const controlY1 = nextCommand[2];
                const controlY2 = nextCommand[4];

                // Calculate curve parameters
                curveCenterX = (startX + endX) / 2;
                curveCenterY = startY;
                curveRadius = Math.abs(endX - startX) / 2;

                // Determine direction
                if (controlY1 < startY || controlY2 < startY) {
                  curveDirection = 1; // down
                }
              }
              break;
            }
          }
        }

        // Add curve metadata
        enhancedObj.curveMetadata = {
          hasCurve: true,
          direction: curveDirection,
          radius: curveRadius,
          centerX: curveCenterX,
          centerY: curveCenterY,
          originalLeft: obj.left,
          originalTop: obj.top,
        };

        // Also add to main metadata
        enhancedObj.metadata.curveInfo = enhancedObj.curveMetadata;
      }

      // Add lock metadata
      if (
        fabricObj.locked ||
        (fabricObj.metadata && fabricObj.metadata.isLocked)
      ) {
        enhancedObj.metadata.lockInfo = {
          isLocked: true,
          storedIndex: fabricObj.metadata
            ? fabricObj.metadata.storedIndex
            : index,
          lockedAt: fabricObj.metadata
            ? fabricObj.metadata.lockedAt
            : new Date().toISOString(),
        };
      }

      // Add type-specific metadata
      if (obj.type === "image") {
        enhancedObj.metadata.imageInfo = {
          originalWidth: fabricObj.width,
          originalHeight: fabricObj.height,
          currentScaleX: fabricObj.scaleX,
          currentScaleY: fabricObj.scaleY,
        };
      }

      if (obj.type === "i-text" || obj.type === "textbox") {
        enhancedObj.metadata.textInfo = {
          originalText: fabricObj.text,
          fontFamily: fabricObj.fontFamily,
          fontSize: fabricObj.fontSize,
          fill: fabricObj.fill,
        };
      }

      return enhancedObj;
    });

    // Add canvas-level metadata
    canvasData.canvasMetadata = {
      exportedAt: new Date().toISOString(),
      totalObjects: canvasData.objects.length,
      canvasWidth: canvas.width,
      canvasHeight: canvas.height,
      backgroundColor: canvas.backgroundColor,
      version: "2.0",
      canvasSize: canvas.width,
      deviceType: window.innerWidth < 768 ? "mobile" : "desktop",
      windowWidth: window.innerWidth,
      fabricVersion: fabric.version,
    };

    return canvasData;
  }

  const exportCanvasImage = () => {
    const dataURL = canvas.toDataURL({
      format: "png",
      quality: 1.0,
      multiplier: 8, // Higher resolution for better quality
    });
    return dataURL;
  };
  // Save Guest function
  const saveGuestDesignFunction = async (targetBtn) => {
    let saveGustBtnLable = "save-guest-design";
    try {
      const assetContainer = targetBtn
        .closest(".customize-disc-container")
        .querySelector(".disc-assets-container");
      canvas.discardActiveObject();
      canvas.renderAll();

      // Export with full metadata
      const canvasDataWithMetadata = exportCanvasWithMetadata();

      // Save JSON string of canvas with metadata
      const json = JSON.stringify(canvasDataWithMetadata);

      discDesign.json = json;
      discDesign.type = "json";

      const dataURL = exportCanvasImage();

      let id = window.generateUniqueId();

      // Disable save btns and show the save-btn loader
      // enableDisableSaveBtns(true, saveGustBtnLable);
      // create function is called
      result = await saveDesignAsGuestInDB(dataURL);

      // Enable save btns and hide the save-btn loader
      // enableDisableSaveBtns(false, saveGustBtnLable);

      let { status, message, imageURL, assets } = result || {};

      let saveGuestConfirmMsg = document.getElementById(
        "save-guest-confirm-msg"
      );
      // Handling response for add  case start here
      if (result.status === true) {
        // Save the canvas assets
        if (Array.isArray(assets) && assets.length > 0) {
          addValuesToAssetContainer(assetContainer, assets);
        }
        document
          .getElementById("view-dics-design-preview-link")
          .classList.remove("hidden");
        // Update the latest image url in hidden input
        document.getElementById("disc-design-data-url").value = imageURL;

        document.getElementById("disc-design-data-url-type").value = "Internal";

        saveGuestConfirmMsg.classList.add("text-green-700");

        saveGuestConfirmMsg.innerHTML =
          " Design link is generated! Continuing to the next step...";

        clearSelectedDesigns();
        window.resetAndRefethDesigns();
      } else {
        saveGuestConfirmMsg.classList.add("text-red-700");
        document.getElementById("save-as-continue-msg").innerHTML = message;
      }

      saveGuestConfirmMsg.classList.remove("hidden");
      setTimeout(() => {
        saveGuestConfirmMsg.classList.add("hidden");
        window.closeModal();
      }, sucessMessageDisappearTime);
    } catch (error) {
      console.log("Error on saving the design : ", error);
    } finally {
      // Disable save btns and show the save-btn loader
      enableDisableSaveBtns(false, saveGustBtnLable);
    }
  };

  // --- Save Guest Design ---
  saveGuestDesignBtn?.addEventListener("click", (event) => {
    const targetBtn = event.currentTarget;
    enableDisableSaveBtns(true, "save-guest-design"); // disable instantly
    // queue after current stack, but don't wait for a full animation frame
    setTimeout(() => saveGuestDesignFunction(targetBtn), 0);
  });

  // --- Save  Design ---
  const saveDesignFunction = async (targetBtn) => {
    try {     
      const assetContainer = targetBtn
        .closest(".customize-disc-container")
        .querySelector(".disc-assets-container");

      // check user is logged in or not
      if (
        window.ShopifyCustomerLoggedIn !== true &&
        window.ShopifyCustomerLoggedIn !== "true"
      ) {
        if (
          confirm(
            "You need to log in to save your design. Would you like to log in now?"
          )
        ) {
          window.location.href = window.ShopifyLoginUrl;
        }
        return;
      }

      document.getElementById("save-confirm-msg").innerHTML = "";
      document.getElementById("save-confirm-msg").classList.remove("hidden");
      if (!hasValidObjects()) {
        let message =
          "Please add text, image, or change background color before saving your design.";
        document
          .getElementById("save-confirm-msg")
          .classList.add("text-red-700");
        document.getElementById("save-confirm-msg").innerHTML = message;
        return false;
      }
      canvas.discardActiveObject();
      canvas.renderAll();

      // Export with full metadata
      const canvasDataWithMetadata = exportCanvasWithMetadata();

      // Save JSON string of canvas with metadata
      const json = JSON.stringify(canvasDataWithMetadata);

      discDesign.json = json;
      discDesign.type = "json";

      const dataURL = exportCanvasImage();

      // let check design is edited.
      let previousDesigns = window.previousDesigns;
      let designIndex = previousDesigns.findIndex((item) => {
        return item.id === canvas.meta.designId;
      });

      let latestImageUrl = "";
      document.getElementById("save-confirm-msg").innerHTML = "";
      document.getElementById("save-confirm-msg").classList.remove("hidden");
      document
        .getElementById("save-confirm-msg")
        .classList.remove("text-green-700");
      document
        .getElementById("save-confirm-msg")
        .classList.remove("text-red-700");

      let isDesignEdited = false;
      let result;
      let responseMessage = "";

      // Disable save btns and show the save-btn loader
      // enableDisableSaveBtns(true, "save-btn");

      // Design is being edited
      if (designIndex !== -1) {
        isDesignEdited = true;
        previousDesigns[designIndex] = {
          id: canvas.meta.designId,
          src: dataURL,
          json,
        };

        // Update function  called
        result = await updateDesignInDB(canvas.meta.designId, json, dataURL);

        // Enable save btns and hide the save-btn loader
        // enableDisableSaveBtns(false, "save-btn");

        let { status, message, imageURL, assets } = result || {};
        successMessage =
          "Design updated! You can now add the product to your cart.";
        latestImageUrl = imageURL;
        responseMessage = message;
        setTimeout(() => {
          clearSelectedDesigns();
          window.previousDesigns = previousDesigns;
          loadPreviousDesign(previousDesigns);
        }, 400);
      } else {
        // New Design is being created

        // let id = window.generateUniqueId();
        // previousDesigns.push({ id, src: dataURL, json });

        // create function is called
        result = await saveDesignInDB(json, dataURL);

        // Enable save btns and hide the save-btn loader
        // enableDisableSaveBtns(false, "save-btn");

        let { status, message, imageURL, assets } = result || {};
        successMessage =
          "Design saved! You can now add the product to your cart.";
        latestImageUrl = imageURL;
        responseMessage = message;
      }

      // Handling response for add and edit case start here
      const { status, message, imageURL, assets } = result || {};
      if (status === true) {
        // Save the canvas assets
        if (Array.isArray(assets) && assets.length > 0) {
          addValuesToAssetContainer(assetContainer, assets);
        }

        // Show the image preview btn
        document
          .getElementById("view-dics-design-preview-link")
          .classList.remove("hidden");

        // Update the latest image url in hidden input
        document.getElementById("disc-design-data-url").value = latestImageUrl;
        document.getElementById("disc-design-data-url-type").value = "Internal";

        document
          .getElementById("save-confirm-msg")
          .classList.add("text-green-700");

        document.getElementById("save-confirm-msg").innerHTML = successMessage;

        // Clear the canvas
        clearCanvas();

        if (isDesignEdited === false) {
          clearSelectedDesigns();
          window.resetAndRefethDesigns();
        }
      } else {
        document
          .getElementById("save-confirm-msg")
          .classList.add("text-red-700");
        document.getElementById("save-confirm-msg").innerHTML = responseMessage;
      }

      // Close the modal and hide the status message
      setTimeout(() => {
        document.getElementById("save-confirm-msg").classList.add("hidden");
        window.closeModal();
      }, sucessMessageDisappearTime);

      // Handling response for add and edit case end here
    } catch (error) {
      console.log("Error on saving the design : ", error);
    } finally {
      // Disable save btns and show the save-btn loader
      enableDisableSaveBtns(false, "save-btn");
    }
  };

  saveDesignBtn?.addEventListener("click", (event) => {
    const targetBtn = event.currentTarget;
    enableDisableSaveBtns(true, "save-btn"); // disable instantly
    
    // queue after current stack, but don't wait for a full animation frame
    setTimeout(() => saveDesignFunction(targetBtn), 0);
  });

  // Export images separately
  function exportAssetsImages() {
    let images = [];

    const canvasObjects = canvas.getObjects();

    const imageObjects = canvasObjects.filter(
      (obj) =>
        obj.type === "image" && (obj.id || (obj.metadata && obj.metadata.id))
    );

    imageObjects.forEach((imgObj, index) => {
      // Get the original image element (unchanged)
      const originalImgElement = imgObj.getElement();

      // Create canvas for original image (without transformations)
      const originalCanvas = document.createElement("canvas");
      const originalCtx = originalCanvas.getContext("2d");

      // Set canvas to original image dimensions
      originalCanvas.width = imgObj.width;
      originalCanvas.height = imgObj.height;

      // Draw original image without any transformations
      originalCtx.drawImage(
        originalImgElement,
        0,
        0,
        imgObj.width,
        imgObj.height
      );
      const originalImageData = originalCanvas.toDataURL("image/png");

      // ALSO get transformed image
      const tempCanvas = document.createElement("canvas");
      const tempCtx = tempCanvas.getContext("2d");
      const actualWidth = imgObj.width * imgObj.scaleX;
      const actualHeight = imgObj.height * imgObj.scaleY;

      tempCanvas.width = actualWidth;
      tempCanvas.height = actualHeight;

      tempCtx.save();
      tempCtx.scale(imgObj.scaleX, imgObj.scaleY);
      tempCtx.rotate((imgObj.angle * Math.PI) / 180);
      tempCtx.drawImage(originalImgElement, 0, 0);
      tempCtx.restore();

      const transformedImageData = tempCanvas.toDataURL("image/png");

      // Convert data URLs to blobs
      const originalBlob = dataURLtoBlob(originalImageData);
      const transformedBlob = dataURLtoBlob(transformedImageData);

      const imageData = {
        id: imgObj.metadata?.id || imgObj.id,
        originalFileName:
          imgObj.metadata?.originalFileName ||
          imgObj.fileName ||
          `image_${index + 1}`,
        originalSrc: originalImageData, // Data URL
        originalBlob: originalBlob, // ← Blob for network request
        originalUploadSrc: imgObj.src,
        transformedSrc: transformedImageData, // Data URL
        transformedBlob: transformedBlob, // ← Blob for network request
        position: {
          left: imgObj.left,
          top: imgObj.top,
        },
        dimensions: {
          width: actualWidth,
          height: actualHeight,
          originalWidth: imgObj.width,
          originalHeight: imgObj.height,
        },
        transforms: {
          scaleX: imgObj.scaleX,
          scaleY: imgObj.scaleY,
          angle: imgObj.angle,
          skewX: imgObj.skewX,
          skewY: imgObj.skewY,
        },
      };

      images.push(imageData);
    });

    return images;
  }

  function addValuesToAssetContainer(container, values) {
    container.innerHTML = "";
    let valuesString = values.join(",");
    let input = document.createElement("input");
    input.type = "hidden";
    input.name = "properties[Disc Assets]"; // Shopify stores as line item property array
    input.value = valuesString;
    container.appendChild(input);
  }

  // Utility: Convert dataURL to Blob
  function dataURLtoBlob(dataurl) {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new Blob([u8arr], { type: mime });
  }

  async function saveDesignInDB(json, dataURL) {
    const jsonBlob = new Blob([JSON.stringify(json)], {
      type: "application/json",
    });

    const imageBlob = dataURLtoBlob(dataURL); // custom function or use fetch+blob
    const formData = new FormData();
    formData.append("canvas_json", jsonBlob, "canvas.json");
    formData.append("preview_image", imageBlob, "preview.png");
    formData.append("email", window.ShopifyCustomerEmail);

    // 👉 Export asset images
    const assetImages = exportAssetsImages();
    assetImages.forEach((img, index) => {
      // Original image
      if (img.originalBlob) {
        formData.append(
          "assets_original",
          img.originalBlob,
          `${img.originalFileName || `asset_${index + 1}`}.png`
        );
      }
    });

    // 6. Send POST request
    try {
      const response = await fetch(
        `${DGSAppBaseUrl}/disc-designs/save-design`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }

      const result = await response.json();
      // console.log("✅ Design saved successfully:", result);
      const { status, message, data = null, error = null } = result || {};
      let imageURL = "";
      let assets = [];
      if (status === true) {
        imageURL = data.imageURL;
        assets = data.assets;
      }

      return {
        status: status,
        message: message,
        imageURL,
        assets,
      };
    } catch (err) {
      console.error("❌ Failed to save design:", err);
      return {
        status: status,
        message: "❌ Failed to save design:",
        imageURL: "",
        assets: [],
      };
    }
  }

  async function saveDesignAsGuestInDB(dataURL) {
    const imageBlob = dataURLtoBlob(dataURL); // custom function or use fetch+blob
    const formData = new FormData();
    formData.append("preview_image", imageBlob, "preview.png");

    // 👉 Export asset images
    const assetImages = exportAssetsImages();
    assetImages.forEach((img, index) => {
      // Original image
      if (img.originalBlob) {
        formData.append(
          "assets_original",
          img.originalBlob,
          `${img.originalFileName || `asset_${index + 1}`}.png`
        );
      }
    });

    // 6. Send POST request
    try {
      const response = await fetch(
        `${DGSAppBaseUrl}/disc-designs/save-as-guest-design`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }

      const result = await response.json();
      // console.log("✅ Design saved successfully:", result);
      const { status, message, data = null, error = null } = result || {};
      let imageURL = "";
      let assets = [];
      if (status === true) {
        imageURL = data.imageURL;
        assets = data.assets;
        // Clear the canvas
        clearCanvas();
      }
      return {
        status: status,
        message: message,
        imageURL,
        assets,
      };
    } catch (err) {
      console.error("❌ Failed to save design:", err);
      return {
        status: status,
        message: "❌ Failed to save design:",
        imageURL: "",
        assets: [],
      };
    }
  }

  // --- Save As Design ---
  const saveAsDesignFunction = async (targetBtn) => {
    try {
      const assetContainer = targetBtn
        .closest(".customize-disc-container")
        .querySelector(".disc-assets-container");
      if (
        window.ShopifyCustomerLoggedIn !== true &&
        window.ShopifyCustomerLoggedIn !== "true"
      ) {
        // check user is logged in or not
        if (
          confirm(
            "You need to log in to save your design. Would you like to log in now?"
          )
        ) {
          window.location.href = window.ShopifyLoginUrl;
        }
        return;
      }
      canvas.discardActiveObject();
      canvas.renderAll();

      // Export with full metadata
      const canvasDataWithMetadata = exportCanvasWithMetadata();

      // Save JSON string of canvas with metadata
      const json = JSON.stringify(canvasDataWithMetadata);

      discDesign.json = json;
      discDesign.type = "json";

      const dataURL = exportCanvasImage();

      let id = window.generateUniqueId();

      // let previousDesigns = window.previousDesigns;
      // previousDesigns.push({ id, src: dataURL, json });

      // Disable save btns and show the save-btn loader
      // enableDisableSaveBtns(true, "save-as-btn");

      // create function is called
      result = await saveDesignInDB(json, dataURL);

      // Enable save btns and hide the save-btn loader
      // enableDisableSaveBtns(false, "save-as-btn");

      let { status, message, imageURL, assets } = result || {};

      // Handling response for add  case start here
      if (result.status === true) {
        // Save the canvas assets
        if (Array.isArray(assets) && assets.length > 0) {
          addValuesToAssetContainer(assetContainer, assets);
        }
        document.getElementById("disc-design-data-url").value = dataURL;
        // discDesign.dataURL = dataURL;

        document
          .getElementById("view-dics-design-preview-link")
          .classList.remove("hidden");
        // Update the latest image url in hidden input
        document.getElementById("disc-design-data-url").value = imageURL;
        document.getElementById("disc-design-data-url-type").value = "Internal";

        document
          .getElementById("save-as-continue-msg")
          .classList.add("text-green-700");

        document.getElementById("save-as-continue-msg").innerHTML =
          " Design is duplicated! Continuing to the next step...";

        clearSelectedDesigns();
        window.resetAndRefethDesigns();
        // Clear the canvas
        clearCanvas();
      } else {
        document
          .getElementById("save-as-continue-msg")
          .classList.add("text-red-700");
        document.getElementById("save-as-continue-msg").innerHTML = message;
      }

      // setTimeout(() => {
      //   window.previousDesigns = previousDesigns;
      //   loadPreviousDesign(previousDesigns);
      // }, 400);

      document
        .getElementById("save-as-continue-msg")
        .classList.remove("hidden");
      setTimeout(() => {
        document.getElementById("save-as-continue-msg").classList.add("hidden");

        window.closeModal();
      }, sucessMessageDisappearTime);
    } catch (error) {
      console.log("Error on saving the design : ", error);
    } finally {
      // Disable save btns and show the save-btn loader
      enableDisableSaveBtns(false, "save-as-btn");
    }
  };
  saveAsDesignBtn?.addEventListener("click", (event) => {
    const targetBtn = event.currentTarget;
    enableDisableSaveBtns(true, "save-as-btn"); // disable instantly

    // queue after current stack, but don't wait for a full animation frame
    setTimeout(() => saveAsDesignFunction(targetBtn), 0);
  });

  async function updateDesignInDB(id, json, dataURL) {
    const jsonBlob = new Blob([JSON.stringify(json)], {
      type: "application/json",
    });

    const imageBlob = dataURLtoBlob(dataURL); // custom function or use fetch+blob
    const formData = new FormData();
    formData.append("canvas_json", jsonBlob, "canvas.json");
    formData.append("preview_image", imageBlob, "preview.png");
    formData.append("id", id);
    formData.append("email", window.ShopifyCustomerEmail);

    // 👉 Export asset images
    const assetImages = exportAssetsImages();
    assetImages.forEach((img, index) => {
      // Original image
      if (img.originalBlob) {
        formData.append(
          "assets_original",
          img.originalBlob,
          `${img.originalFileName || `asset_${index + 1}`}.png`
        );
      }
    });

    // 6. Send POST request
    try {
      const response = await fetch(
        `${DGSAppBaseUrl}/disc-designs/update-design`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }

      const result = await response.json();
      // console.log("✅ Design updated successfully:", result);

      const { status, message, data = null, error = null } = result || {};
      let imageURL = "";
      let assets = [];
      if (status === true) {
        imageURL = data.imageURL;
        assets = data.assets;
      }
      return {
        status: status,
        message: message,
        imageURL,
        assets,
      };
    } catch (err) {
      console.error("❌ Failed to update design:", err);
      return {
        status: status,
        message: "❌ Failed to update design:",
        imageURL: "",
        assets: [],
      };
    }
  }

  function enableDisableSaveBtns(enable, btnType) {
    
    if (enable === true) {
      // Save btn
      if (saveDesignBtn) {
        if (btnType === "save-btn") {
          saveLoadingIndicator.classList.remove("hidden");
        }
        saveDesignBtn.classList.add("opacity-50", "cursor-not-allowed");
        console.log("ok2")
      }

      // Save as btn
      if (saveAsDesignBtn) {
        if (btnType === "save-as-btn") {
          saveAsLoadingIndicator.classList.remove("hidden");
        }
        saveAsDesignBtn.classList.add("opacity-50", "cursor-not-allowed");
      }

      // Guest Btn
      if (saveGuestDesignBtn) {
        if (btnType === "save-guest-design") {
          saveGuuestLoadingIndicator.classList.remove("hidden");
        }
        saveGuestDesignBtn.classList.add("opacity-50", "cursor-not-allowed");
      }
    } else {
      // Save design
      if (saveDesignBtn) {
        saveLoadingIndicator.classList.add("hidden");
        saveDesignBtn.classList.remove("opacity-50", "cursor-not-allowed");
      }
      if (saveAsDesignBtn) {
        // Save as design
        saveAsLoadingIndicator.classList.add("hidden");
        saveAsDesignBtn.classList.remove("opacity-50", "cursor-not-allowed");
      }

      // Save as guest design
      if (saveGuestDesignBtn) {
        saveGuuestLoadingIndicator.classList.add("hidden");
        saveGuestDesignBtn.classList.remove("opacity-50", "cursor-not-allowed");
      }
    }
  }

  const testBtn = document.querySelector(".test-btn");
  testBtn?.addEventListener("click", async function (e) {
    alert("testBtn");
    return false;
  });

  const createDesignAddToCartBtn = document.querySelector(
    ".createDesignAddToCartBtn"
  );
  // Handle click event to create design tab add to cart button
  createDesignAddToCartBtn?.addEventListener("click", function (event) {
    let This = this;
    
    
    const modalCartWrapper = this.closest(".modal-cart-wrapper");
    const productQuantity = modalCartWrapper.querySelector(".modal-product-quantity").value;     
    document.querySelector("input.product-qunatity[name='quantity']").value = productQuantity;
    


    This.classList.add("opacity-50", "cursor-not-allowed");
    const targetBtn = event.currentTarget;
    if (
      window.ShopifyCustomerLoggedIn !== true &&
      window.ShopifyCustomerLoggedIn !== "true"
    ) {
      enableDisableSaveBtns(true, "save-guest-design"); // disable instantly
      // queue after current stack, but don't wait for a full animation frame
      setTimeout(async () => {
        await saveGuestDesignFunction(targetBtn)
        This.closest(".atc-btn-container").querySelector(".add_to_cart").click();
        This.classList.remove("opacity-50", "cursor-not-allowed");
      }, 0);
    } else {
      enableDisableSaveBtns(true, "save-btn"); // disable instantly
      // queue after current stack, but don't wait for a full animation frame
      setTimeout(async () => {
        await saveDesignFunction(targetBtn)
        This.closest(".atc-btn-container").querySelector(".add_to_cart").click();
        This.classList.remove("opacity-50", "cursor-not-allowed");
      }, 0);
    }

    
    
  });

  // Function to add metadata and index to objects
  function addMetadataToObject(object, customMetadata = {}) {
    // Add current index
    const currentIndex = canvas.getObjects().indexOf(object);

    // Add metadata property with default values and custom data
    object.metadata = {
      id: window.generateUniqueId(),
      createdAt: new Date().toISOString(),
      type: object.type,
      currentIndex: currentIndex,
      originalIndex: currentIndex,
      isLocked: false,
      category: getObjectCategory(object.type),
      ...customMetadata, // Spread any additional custom metadata
    };

    // Update index in metadata whenever object position changes
    updateObjectIndex(object);

    return object;
  }

  // Get category based on object type
  function getObjectCategory(type) {
    const categories = {
      "i-text": "text",
      textbox: "text",
      image: "image",
      rect: "shape",
      circle: "shape",
      path: "shape",
    };
    return categories[type] || "other";
  }

  // Update object index in metadata
  function updateObjectIndex(object) {
    if (object.metadata) {
      object.metadata.currentIndex = canvas.getObjects().indexOf(object);
      object.metadata.lastUpdated = new Date().toISOString();
    }
  }

  // Update all objects' indices
  function updateAllObjectIndices() {
    canvas.getObjects().forEach((obj, index) => {
      if (obj.metadata) {
        obj.metadata.currentIndex = index;
        obj.metadata.lastUpdated = new Date().toISOString();
      }
    });
  }

  // Enhanced lock/unlock button handler
  lockUnlockBtn?.addEventListener("click", () => {
    const activeObject = canvas.getActiveObject();
    if (activeObject) {
      toggleObjectLock(activeObject);
      updateControls();
    }
  });

  // Enhanced toggleObjectLock function
  function toggleObjectLock(object) {
    if (!object.metadata) {
      addMetadataToObject(object);
    }

    const currentIndex = canvas.getObjects().indexOf(object);

    if (object.metadata.isLocked) {
      // Unlock object
      object.metadata.isLocked = false;
      object.locked = false;
      object.selectable = true;
      object.evented = true;
      object.lockMovementX = false;
      object.lockMovementY = false;
      object.lockScalingX = false;
      object.lockScalingY = false;
      object.lockRotation = false;

      // Clear stored index and flags
      delete object.metadata.storedIndex;
      delete object._preventBringToFront;
      delete object._needsPositionRestore;
      delete object._originalIndex;

      // Update visual indicators
      object.set({
        borderColor: "rgba(66, 153, 225, 0.8)",
        cornerColor: "#4299e1",
      });

      // console.log(`Object unlocked at index ${currentIndex}`);
    } else {
      // Lock object
      object.metadata.isLocked = true;
      object.locked = true;
      object.lockMovementX = true;
      object.lockMovementY = true;
      object.lockScalingX = true;
      object.lockScalingY = true;
      object.lockRotation = true;

      // Store current index as the locked position
      object.metadata.storedIndex = currentIndex;
      object.metadata.lockedAt = new Date().toISOString();

      // Update visual indicators
      object.set({
        borderColor: "rgba(255, 193, 7, 0.8)",
        cornerColor: "#ffc107",
      });

      // console.log(`Object locked at index ${currentIndex}`);
    }

    // Update metadata
    object.metadata.currentIndex = currentIndex;
    object.metadata.lastUpdated = new Date().toISOString();

    canvas.renderAll();
  }

  // Activate locak if object is locked, activate unlock if object is unlocked
  function activateObjectLockUnlock(object) {
    if (!object.metadata) {
      addMetadataToObject(object);
    }

    const currentIndex = canvas.getObjects().indexOf(object);

    if (object.metadata.isLocked === false) {
      // Unlock object
      object.metadata.isLocked = false;
      object.locked = false;
      object.selectable = true;
      object.evented = true;
      object.lockMovementX = false;
      object.lockMovementY = false;
      object.lockScalingX = false;
      object.lockScalingY = false;
      object.lockRotation = false;

      // Clear stored index and flags
      delete object.metadata.storedIndex;
      delete object._preventBringToFront;
      delete object._needsPositionRestore;
      delete object._originalIndex;

      // Update visual indicators
      object.set({
        borderColor: "rgba(66, 153, 225, 0.8)",
        cornerColor: "#4299e1",
      });

      // console.log(`Object unlocked at index ${currentIndex}`);
    } else {
      // Lock object
      object.metadata.isLocked = true;
      object.locked = true;
      object.lockMovementX = true;
      object.lockMovementY = true;
      object.lockScalingX = true;
      object.lockScalingY = true;
      object.lockRotation = true;

      // Store current index as the locked position
      object.metadata.storedIndex = currentIndex;
      object.metadata.lockedAt = new Date().toISOString();

      // Update visual indicators
      object.set({
        borderColor: "rgba(255, 193, 7, 0.8)",
        cornerColor: "#ffc107",
      });

      // console.log(`Object locked at index ${currentIndex}`);
    }

    // Update metadata
    object.metadata.currentIndex = currentIndex;
    object.metadata.lastUpdated = new Date().toISOString();

    canvas.renderAll();
  }

  // Function that runs when an object becomes active
  // Enhanced handleObjectActivation function
  function handleObjectActivation(activeObject) {
    // console.log("Object activated:", activeObject.type);

    if (activeObject.metadata) {
      // console.log("Object lock status:", activeObject.metadata.isLocked);
      // console.log("Current index:", activeObject.metadata.currentIndex);

      // If object is locked, restore its position immediately
      if (activeObject.metadata.isLocked || activeObject.locked) {
        // console.log("Object is locked - maintaining current position");
        // Force position restoration
        restoreObjectToOriginalPosition(activeObject);
      } else {
        // console.log("Object is unlocked - allowing reshuffling");
        handleUnlockedObjectSelection(activeObject);
      }
    } else {
      // console.log("No metadata found - treating as unlocked");
      handleUnlockedObjectSelection(activeObject);
    }
  }

  // Restore locked object to its original/stored position
  // Enhanced restoreObjectToOriginalPosition function
  function restoreObjectToOriginalPosition(object) {
    if (object.metadata && object.metadata.storedIndex !== undefined) {
      const currentIndex = canvas.getObjects().indexOf(object);
      const targetIndex = object.metadata.storedIndex;

      if (currentIndex !== targetIndex && targetIndex >= 0) {
        // console.log(
        //   `Restoring locked object from index ${currentIndex} to ${targetIndex}`
        // );

        // Use moveTo instead of remove/insert for better performance
        canvas.moveTo(object, targetIndex);

        // Update metadata
        object.metadata.currentIndex = targetIndex;
        object.metadata.lastRestored = new Date().toISOString();

        // Clear restoration flags
        delete object._needsPositionRestore;
        delete object._originalIndex;

        // Force re-render
        canvas.renderAll();
      }
    }
  }

  // Handle unlocked object selection (allow bringing to front)
  // Enhanced handleUnlockedObjectSelection function
  function handleUnlockedObjectSelection(object) {
    const currentIndex = canvas.getObjects().indexOf(object);

    // Only bring to front if it's not already at the top
    if (currentIndex < canvas.getObjects().length - 1) {
      // Store current position before moving
      if (object.metadata) {
        object.metadata.previousIndex = currentIndex;
      }

      // Bring to front for better interaction
      canvas.bringToFront(object);

      // Update metadata after moving
      if (object.metadata) {
        object.metadata.currentIndex = canvas.getObjects().indexOf(object);
        object.metadata.lastMoved = new Date().toISOString();
      }

      // console.log(
      //   `Unlocked object moved to front (index: ${
      //     object.metadata ? object.metadata.currentIndex : "unknown"
      //   })`
      // );
      canvas.renderAll();
    }
  }

  // Override ALL Fabric.js methods that could change object order
  const originalBringToFront = fabric.Object.prototype.bringToFront;
  fabric.Object.prototype.bringToFront = function () {
    if ((this.metadata && this.metadata.isLocked) || this.locked) {
      // console.log("Prevented bringToFront for locked object");
      return this;
    }
    return originalBringToFront.call(this);
  };

  const originalBringForward = fabric.Object.prototype.bringForward;
  fabric.Object.prototype.bringForward = function (intersecting) {
    if ((this.metadata && this.metadata.isLocked) || this.locked) {
      // console.log("Prevented bringForward for locked object");
      return this;
    }
    return originalBringForward.call(this, intersecting);
  };

  const originalSendToBack = fabric.Object.prototype.sendToBack;
  fabric.Object.prototype.sendToBack = function () {
    if ((this.metadata && this.metadata.isLocked) || this.locked) {
      // console.log("Prevented sendToBack for locked object");
      return this;
    }
    return originalSendToBack.call(this);
  };

  const originalSendBackwards = fabric.Object.prototype.sendBackwards;
  fabric.Object.prototype.sendBackwards = function (intersecting) {
    if ((this.metadata && this.metadata.isLocked) || this.locked) {
      // console.log("Prevented sendBackwards for locked object");
      return this;
    }
    return originalSendBackwards.call(this, intersecting);
  };

  // Utility function to force restore all locked objects
  function forceRestoreAllLockedObjects() {
    // console.log("Force restoring all locked objects...");
    canvas.getObjects().forEach((obj, currentIndex) => {
      if ((obj.metadata && obj.metadata.isLocked) || obj.locked) {
        if (
          obj.metadata &&
          obj.metadata.storedIndex !== undefined &&
          obj.metadata.storedIndex !== currentIndex
        ) {
          // console.log(
          //   `Force restoring object from ${currentIndex} to ${obj.metadata.storedIndex}`
          // );
          canvas.moveTo(obj, obj.metadata.storedIndex);
        }
      }
    });
    updateAllObjectIndices();
    canvas.renderAll();
  }

  // Call this function periodically if needed (for debugging)
  // setInterval(forceRestoreAllLockedObjects, 1000);

  // --- Initialize everything ---
  initializeCanvas();
  updateControls();

  // Function to clear the canvas with various options
  function clearCanvas(options = {}) {
    const {
      confirmBeforeClear = false,
      resetBackground = true,
      resetToDefaultBackground = "#ffffff",
      clearMetadata = true,
      showNotification = false,
      animateTransition = false,
    } = options;

    // Confirmation dialog
    if (confirmBeforeClear) {
      const confirmed = confirm(
        "Are you sure you want to clear the entire canvas? This action cannot be undone."
      );
      if (!confirmed) {
        return false; // User cancelled
      }
    }

    // Store current state for potential undo (optional)
    const beforeClearState = {
      objects: canvas.getObjects().length,
      backgroundColor: canvas.backgroundColor,
      metadata: canvas.canvasMetadata || null,
    };

    try {
      // Animate transition if requested
      if (animateTransition && canvas.getObjects().length > 0) {
        // Fade out all objects
        canvas.getObjects().forEach((obj, index) => {
          setTimeout(() => {
            obj.animate("opacity", 0, {
              duration: 300,
              onChange: canvas.renderAll.bind(canvas),
              onComplete: () => {
                if (index === canvas.getObjects().length - 1) {
                  // After last object fades, clear everything
                  performClear();
                }
              },
            });
          }, index * 50); // Stagger the animations
        });
      } else {
        // Clear immediately
        performClear();
      }

      // Internal function to perform the actual clearing
      function performClear() {
        // Clear all objects from canvas
        canvas.clear();

        // Reset background if requested
        if (resetBackground) {
          canvas.setBackgroundColor(
            resetToDefaultBackground,
            canvas.renderAll.bind(canvas)
          );

          // Update UI background color selector if it exists
          updateBackgroundColorUI(resetToDefaultBackground);
        }

        // Clear canvas metadata if requested
        if (clearMetadata) {
          canvas.canvasMetadata = null;
          canvas.meta = {};
        }

        // Clear any active selections
        canvas.discardActiveObject();

        // Reset zoom and pan if they exist
        if (canvas.getZoom && canvas.getZoom() !== 1) {
          canvas.setZoom(1);
        }
        if (
          canvas.viewportTransform &&
          (canvas.viewportTransform[4] !== 0 ||
            canvas.viewportTransform[5] !== 0)
        ) {
          canvas.viewportTransform[4] = 0;
          canvas.viewportTransform[5] = 0;
        }

        // Update UI controls
        if (typeof updateControls === "function") {
          updateControls();
        }

        // Trigger canvas change handler if it exists
        if (typeof handleChangeInCanvas === "function") {
          handleChangeInCanvas();
        }

        // Final render
        canvas.renderAll();

        // Show notification if requested
        if (showNotification) {
          let message = `
              <strong>✅ Canvas is cleared successfully.</strong><br>
              <small>Removed ${beforeClearState.objects} object(s)</small>
            `;
          showCanvasNotification((success = true), message);
        }

        // console.log("Canvas cleared successfully");
      }

      return true; // Successfully cleared
    } catch (error) {
      console.error("Error clearing canvas:", error);

      // Show error notification
      if (showNotification) {
        let message = "Failed to clear canvas. Please try again.";
        showCanvasNotification((success = false), message);
      }

      return false; // Failed to clear
    }
  }
  // Helper function to update background color UI
  function updateBackgroundColorUI(color) {
    const bgPalette = document.getElementById("bg-color-palette");
    if (bgPalette) {
      // Remove 'selected' class from all color swatches
      bgPalette.querySelectorAll(".color-swatch").forEach((swatch) => {
        swatch.classList.remove("selected");
      });

      // Add 'selected' class to the matching color
      const matchingColor = bgPalette.querySelector(`[data-color="${color}"]`);
      if (matchingColor) {
        matchingColor.classList.add("selected");
      }
    }
  }

  // Helper function to show success notification
  function showCanvasNotification(success, message) {
    // Try to find existing notification area or create one
    let notificationWrapper = document.getElementById(
      "canvas-clear-notification-wrapper"
    );
    let notification = document.getElementById("canvas-clear-notification");

    notification.innerHTML = message;
    notificationWrapper.classList.remove("hidden");
    if (success === true) {
      notification.classList.remove("alert-danger");
      notification.classList.add("alert-success");
    } else {
      notification.classList.add("alert-danger");
      notification.classList.remove("alert-success");
    }

    // Hide after 1.5 seconds
    setTimeout(() => {
      notificationWrapper.classList.add("hidden");
    }, 1500);
  }

  const clearCanvasBtn = document.getElementById("clear-canvas-button");
  clearCanvasBtn.addEventListener("click", () => {
    clearCanvas({ confirmBeforeClear: true, showNotification: true });
  });

  function scrollToDivWithOffset(divId = "disc-canvas", offset = 200) {
    // scrollToDivWithOffsetMobileAlert();return

    const element = document.getElementById(divId);
    if (element) {
      const modal = element.closest(".customize-dics-modal");
      const container = modal
        ? modal.querySelector(".create-disc-wrapper")
        : null;

      if (container) {
        const y = element.offsetTop + offset;
        container.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }

  function scrollToDivWithOffsetMobileAlert(
    divId = "disc-canvas",
    offset = 200
  ) {
    const element = document.getElementById(divId);

    if (!element) {
      alert("❌ Element not found: " + divId);
      return;
    }

    const modal = element.closest(".customize-dics-modal");
    if (!modal) {
      alert("❌ Modal not found");
      return;
    }

    const container = modal.querySelector(".create-disc-wrapper");
    if (!container) {
      alert("❌ Container not found");
      return;
    }

    const info = `
      Container Info:
      - ScrollTop: ${container.scrollTop}
      - ScrollHeight: ${container.scrollHeight}
      - ClientHeight: ${container.clientHeight}
      - Element offsetTop: ${element.offsetTop}
      - Target Y: ${element.offsetTop + offset}
          `.trim();

    // alert(info);

    container.scrollTo({ top: element.offsetTop + offset, behavior: "smooth" });

    // setTimeout(() => {
    //     alert(`After scroll: ${container.scrollTop}`);
    // }, 1000);
  }

  /* ------------------------------------------------------------------------JS for creeate design tab end here------------------------------------------------------------------------------*/

  /* ------------------------------------------------------------------------JS for load designs start here------------------------------------------------------------------------------*/
  // Sample image data — add more src values as needed
  let defaultSelectedDesignValues = { id: null, json: null, src: null };
  let selectedDesign = defaultSelectedDesignValues;

  function loadPreviousDesign(previousDesigns) {
    if (previousDesigns.length === 0) {
      return false;
    }

    const container = document.querySelector(
      ".load-custom-disc-preview-container"
    );

    container.innerHTML = ""; // Clear existing content
    previousDesigns.forEach((design) => {
      let { src, json, id } = design;
      const img = document.createElement("img");
      img.classList.add("preview-image");
      img.src = design.src;
      img.alt = "Design Image Preview";
      img["data-json"] = json;

      // Attach click handler to select
      img.addEventListener("click", () => {
        document
          .querySelectorAll(
            ".load-custom-disc-preview-container .preview-image"
          )
          .forEach((el) => el.classList.remove("selected"));
        img.classList.add("selected");

        selectedDesign = { json, src, id };

        UseSavedDesignBtn.classList.remove("!hidden");
      });

      img.addEventListener("dblclick", function () {
        // Your logic here
        handleUseSavedDesignAction();
      });
      container.appendChild(img);
    });
  }

  // clear the selected design before loading
  function clearSelectedDesigns() {
    selectedDesign = defaultSelectedDesignValues;
    // hide the use design btn
    UseSavedDesignBtn.classList.add("!hidden");
  }

  // Optional: Call the function on load
  // document.addEventListener("DOMContentLoaded", loadPreviousDesign);

  loadPreviousDesign(window.previousDesigns);
  window.loadPreviousDesign = loadPreviousDesign;

  // const loadDesignBtn = document.getElementById("loadDesignBtn");
  const UseSavedDesignBtn = document.getElementById("UseSavedDesignBtn");

  // Helper function to scale objects during import
  const scaleObjectForImport = (obj, scaleFactor, currentCanvasSize) => {
    // Scale position
    if (obj.left !== undefined) obj.left = obj.left * scaleFactor;
    if (obj.top !== undefined) obj.top = obj.top * scaleFactor;

    // Scale based on object type
    if (obj.type === "i-text" || obj.type === "text") {
      // Scale font size with limits
      if (obj.fontSize) {
        const newFontSize = obj.fontSize * scaleFactor;
        const minFontSize = 12;
        const maxFontSize = 48;
        obj.fontSize = Math.min(
          Math.max(newFontSize, minFontSize),
          maxFontSize
        );
      }

      // Scale curved text paths
      if (obj.path?.path) {
        obj.path.path.forEach((command) => {
          for (let i = 1; i < command.length; i++) {
            if (typeof command[i] === "number") {
              command[i] *= scaleFactor;
            }
          }
        });
      }
    } else if (obj.type === "image") {
      // Scale image dimensions
      if (obj.scaleX) obj.scaleX = obj.scaleX * scaleFactor;
      if (obj.scaleY) obj.scaleY = obj.scaleY * scaleFactor;
    }

    // Ensure objects stay within bounds
    const padding = currentCanvasSize * 0.05;
    obj.left = Math.max(
      padding,
      Math.min(currentCanvasSize - padding, obj.left)
    );
    obj.top = Math.max(padding, Math.min(currentCanvasSize - padding, obj.top));
  };

  let handleUseSavedDesignAction = () => {
    let loadDesignError = document.getElementById("load-design-error");

    let { id, src, json } = selectedDesign;

    if (json === null) {
      let message = "Kindly select at least one design.";
      loadDesignError.innerHTML = message;
    } else {
      loadDesignError.innerHTML = "";
    }

    isImporting = true;
    try {
      // 1. DEEP CLONE the JSON to avoid mutationst
      let originalJson;
      if (typeof json === "string") {
        originalJson = JSON.parse(json);
      } else {
        originalJson = JSON.parse(JSON.stringify(json)); // Deep clone if object
      }
      // 2. Determine scaling
      let originalCanvasSize =
        originalJson.canvasMetadata?.canvasSize || originalJson.width || 500;
      const currentCanvasSize = canvas.width;
      const scaleFactor = currentCanvasSize / originalCanvasSize;

      // 3. Clear canvas completely with fabric.js method
      canvas.clear();
      canvas.setViewportTransform([1, 0, 0, 1, 0, 0]); // Reset viewport
      curvedTextStates.clear();
      images = [];

      // Set background color
      if (originalJson.background) {
        canvas.setBackgroundColor(originalJson.background);
        updateBackgroundColorUI(originalJson.background);
      }

      // 4. Scale a COPY of objects, not originals
      const scaledObjects = originalJson.objects
        ? originalJson.objects.map((obj) => {
            const scaledObj = JSON.parse(JSON.stringify(obj)); // Deep clone each object
            if (scaleFactor !== 1) {
              scaleObjectForImport(scaledObj, scaleFactor, currentCanvasSize);
            }
            return scaledObj;
          })
        : [];

      // First, clean the JSON to prevent loading issues
      const cleanedJson = { ...originalJson };
      const metadataStore = []; // Store metadata for restoration

      if (cleanedJson.objects) {
        cleanedJson.objects = scaledObjects.map((obj, index) => {
          // Store the original data but remove the path for loading
          const cleanObj = JSON.parse(JSON.stringify(obj)); // Another deep clone
          // Store all metadata for later restoration
          metadataStore[index] = {
            metadata: cleanObj.metadata,
            curveMetadata: cleanObj.curveMetadata,
            originalPath: cleanObj.path,
            lockInfo: cleanObj.metadata?.lockInfo,
            hasCustomProperties: true,
          };

          if (obj.type === "i-text" && obj.path) {
            cleanObj._originalPath = obj.path;
            cleanObj._curveMetadata = obj.curveMetadata;
            delete cleanObj.path; // This prevents fabric.js loading errors
            // return cleanObj;
          }
          // Remove custom metadata that might cause loading issues
          delete cleanObj.metadata;
          delete cleanObj.curveMetadata;
          // return obj;
          return cleanObj;
        });
      }

      // Load the cleaned JSON
      canvas.loadFromJSON(cleanedJson, () => {
        setTimeout(() => {
          // Now restore curves to text objects
          canvas.getObjects().forEach((canvasObj, index) => {
            const storedMetadata = metadataStore[index];
            const originalObj = originalJson.objects[index]; // Use original JSON, not cleaned

            if (!storedMetadata || !originalObj) return;

            // Restore base metadata
            if (storedMetadata.metadata) {
              canvasObj.metadata = storedMetadata.metadata;
            }
            // Restore lock functionality
            if (storedMetadata.lockInfo?.isLocked) {
              canvasObj.locked = true;
              canvasObj.set({
                borderColor: "rgba(255, 193, 7, 0.8)",
                cornerColor: "#ffc107",
              });

              // Restore stored z-index if available
              if (storedMetadata.lockInfo.storedIndex !== undefined) {
                canvasObj.metadata.storedIndex =
                  storedMetadata.lockInfo.storedIndex;
              }
            }

            if (
              canvasObj.type === "i-text" &&
              originalObj &&
              originalObj.path
            ) {
              // Add try-catch here
              try {
                // Try to recreate the curve using the original approach
                const radius = canvas.width * 0.4;
                const cx = canvasObj.left;
                const cy = canvasObj.top;

                // Determine direction from metadata if available
                let direction = 0; // default up
                if (originalObj.curveMetadata) {
                  direction = originalObj.curveMetadata.direction;
                }

                const pathDataStr = `M ${
                  cx - radius
                }, ${cy} A ${radius},${radius} 0 0,${direction} ${
                  cx + radius
                },${cy}`;
                const path = new fabric.Path(pathDataStr, {
                  visible: false,
                });

                // Calculate appropriate character spacing for the current canvas size
                const textLength = canvasObj.text ? canvasObj.text.length : 1;
                const baseSpacing = canvas.width < 400 ? 20 : 30;
                const dynamicSpacing = Math.max(
                  baseSpacing - textLength * 2,
                  10
                );

                canvasObj.set({
                  path: path,
                  textAlign: "center",
                  charSpacing: dynamicSpacing, // Add this line
                });

                // store teh curved text state
                storeCurvedTextState(canvasObj);
              } catch (error) {
                console.warn("Failed to restore curve for text:", error);
              }
            }

            // Restore image-specific properties
            if (
              canvasObj.type === "image" &&
              storedMetadata.metadata?.imageInfo
            ) {
              const imageInfo = storedMetadata.metadata.imageInfo;
              canvasObj.metadata.imageInfo = imageInfo;

              // Add the restored image to the images array
              images.push(canvasObj);
            }

            // Restore text-specific properties
            if (
              (canvasObj.type === "i-text" || canvasObj.type === "textbox") &&
              storedMetadata.metadata?.textInfo
            ) {
              const textInfo = storedMetadata.metadata.textInfo;
              canvasObj.metadata.textInfo = textInfo;
            }
            canvasObj.setCoords();
            activateObjectLockUnlock(canvasObj);
          });

          // Set canvas metadata
          if (json.canvasMetadata) {
            canvas.canvasMetadata = json.canvasMetadata;
          }

          // Set design ID
          canvas.meta = canvas.meta || {};
          canvas.meta.designId = id;

          // Update clip path
          updateClipPath(currentCanvasSize);

          canvas.renderAll();
          handleChangeInCanvas();
          isImporting = false;
          

          // Update UI controls if there's a selected object
          const activeObject = canvas.getActiveObject();
          if (activeObject && typeof updateControls === "function") {
            updateControls();
          }

          let tabId = "tab1";
          document
            .getElementById("save-as-continue-btn")
            ?.classList?.remove("hidden");

          if (typeof window.activeGivenTab === "function") {
            window.activeGivenTab(tabId);
          }
        }, 300);
      });
    } catch (error) {
      console.error("Import error:", error);
      alert("Error importing design. Please check the file format.");
      isImporting = false;
    }
  };

  function validateImportedDesign(canvas) {
    const objects = canvas.getObjects();
    let validationReport = {
      totalObjects: objects.length,
      lockedObjects: 0,
      curvedTextObjects: 0,
      objectsWithMetadata: 0,
    };

    objects.forEach((obj) => {
      if (obj.locked) validationReport.lockedObjects++;
      if (obj.curveMetadata) validationReport.curvedTextObjects++;
      if (obj.metadata) validationReport.objectsWithMetadata++;
    });

    // console.log("Design Import Validation:", validationReport);
    return validationReport;
  }

  // Call validation after import (optional)
  // validateImportedDesign(canvas);

  UseSavedDesignBtn.addEventListener("click", handleUseSavedDesignAction);
  function handleChangeInCanvas() {
    hasValidObjects();
    scrollToDivWithOffset();
  }
});

/* ------------------------------------------------------------------------JS for load designs end here------------------------------------------------------------------------------*/
